// Divya Ratna — Kundli Making
//
// This lives in assets/ rather than inline in the section because a Shopify
// template file may not exceed 256 KB and this script alone is most of that.
// It is plain JavaScript: asset files are not rendered through Liquid, so the
// handful of values the section knows arrive through the config argument
// instead of being interpolated into the source.
//
// The section calls window.initKundliMaking(config) immediately after loading
// this file, once per instance, so two of these on one page each get their own
// closure and their own element ids.
window.initKundliMaking = function (config) {
  'use strict';
  config = config || {};
  const sId = config.sectionId;
  const prefix = 'km_';

  // DOM refs
  const form = document.getElementById('kundliForm-' + sId);
  const submitBtn = document.getElementById('kundliSubmitBtn-' + sId);
  const results = document.getElementById('kundliResults-' + sId);
  const placeholder = document.getElementById('kundliPlaceholder-' + sId);
  const apiError = document.getElementById('kundliApiError-' + sId);
  const errorText = document.getElementById('kundliErrorText-' + sId);
  const actions = document.getElementById('kundliActions-' + sId);
  const saveBtn = document.getElementById('saveBtn-' + sId);
  const shareBtn = document.getElementById('shareBtn-' + sId);
  const overlay = document.getElementById('kundliReportOverlay-' + sId);
  const closeBtn = document.getElementById('closeReportBtn-' + sId);
  const historyEl = document.getElementById('kundliHistory-' + sId);
  const historyList = document.getElementById('historyList-' + sId);

  var lastResultsData = null;
  var lastFormData = null;
  var storedPayment = null; // Holds { razorpay_payment_id, razorpay_order_id, razorpay_signature } after successful payment

  // Razorpay configuration
  var RAZORPAY_KEY_ID = ''; // Will be set after create-order response

  // API endpoint
  // A configured proxy URL is used as given; otherwise fall back to the
  // store's own app-proxy path.
  var configuredEndpoint = (config.apiEndpoint || '').trim();
  var shopUrl = (config.shopUrl || '').trim();
  var API_ENDPOINT = (configuredEndpoint || shopUrl) + '/apps/kundli-making';
  if (configuredEndpoint !== '' && configuredEndpoint !== shopUrl) {
    API_ENDPOINT = configuredEndpoint;
  }

  // ==============================================================
  //  DEV MODE — Skip real API calls, use dummy data for UI/design work
  //  Activate by adding ?dev=1 to the URL or set localStorage dev_mode=true
  //  Add ?dev=0 to force-disable
  // ==============================================================
  // localStorage can throw outright (sandboxed frame, blocked cookies, Safari
  // private mode). An uncaught throw here would kill this entire script, so
  // every access goes through these guards.
  function lsGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }
  function lsSet(key, value) {
    try { localStorage.setItem(key, value); } catch (e) { /* non-fatal */ }
  }

  var IS_DEV_MODE = (function() {
    var urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('dev') === '0') { lsSet('km_dev_mode', 'false'); return false; }
    if (urlParams.get('dev') === '1') { lsSet('km_dev_mode', 'true'); return true; }
    return lsGet('km_dev_mode') === 'true';
  })();

  // Show dev badge if active
  if (IS_DEV_MODE) {
    var devBadge = document.createElement('div');
    devBadge.id = 'devModeBadge';
    devBadge.style.cssText = 'position:fixed;top:10px;right:10px;z-index:99999;background:#ff6b35;color:#fff;padding:6px 14px;border-radius:20px;font-family:monospace;font-size:12px;font-weight:700;cursor:pointer;box-shadow:0 2px 10px rgba(255,107,53,0.4);';
    devBadge.textContent = '⚡ DEV MODE';
    devBadge.title = 'Click to disable dev mode';
    devBadge.addEventListener('click', function() {
      localStorage.removeItem('km_dev_mode');
      window.location.search = 'dev=0';
    });
    document.body.appendChild(devBadge);
  }

  // ==============================================================
  //  DEV MODE TOGGLE FUNCTION (called from inline onclick)
  // ==============================================================
  window.toggleDevMode = function(sectionId) {
    var currentMode = localStorage.getItem('km_dev_mode') === 'true';
    if (currentMode) {
      localStorage.setItem('km_dev_mode', 'false');
    } else {
      localStorage.setItem('km_dev_mode', 'true');
    }
    window.location.reload();
  };

  // Update the toggle UI to reflect current mode
  (function updateDevToggle() {
    var label = document.getElementById('devModeLabel-' + sId);
    var indicator = document.getElementById('devModeIndicator-' + sId);
    if (label && indicator) {
      if (IS_DEV_MODE) {
        label.textContent = 'DEV: ON';
        label.style.color = '#ff6b35';
        indicator.style.background = '#ff6b35';
        indicator.style.boxShadow = '0 0 8px rgba(255,107,53,0.6)';
      } else {
        label.textContent = 'DEV: OFF';
        label.style.color = 'rgba(245,232,208,0.5)';
        indicator.style.background = '#666';
        indicator.style.boxShadow = 'none';
      }
    }
  })();

  // ==============================================================
  //  DUMMY PARSED DATA for dev mode (matches parseApiData output)
  // ==============================================================
  function getDummyParsedData() {
    return {
      nakshatra: 'Rohini (Moon)',
      rashi: 'Vrishabha',
      lagna: 'Simha (Leo)',
      pada: '3',
      nakshatraInfo: {
        deity: 'Prajapati (Brahma)',
        ganam: 'Manushya',
        birth_stone: 'Moonstone (Pearl)',
        symbol: 'Chariot / Temple cart',
        color: 'White',
        best_direction: 'South-East',
        syllables: 'Ve, Vo, Va, Vi',
        gender: 'Female'
      },
      rawNakshatra: {
        nakshatra: { name: 'Rohini', pada: 3, lord: { name: 'Moon' } },
        chandra_rasi: { name: 'Vrishabha (Taurus)' },
        soorya_rasi: { name: 'Simha (Leo)' },
        zodiac: { name: 'Simha' },
        additional_info: {
          deity: 'Prajapati (Brahma)',
          ganam: 'Manushya',
          birth_stone: 'Pearl',
          symbol: 'Chariot',
          color: 'White',
          best_direction: 'South-East',
          syllables: 'Ve, Vo, Va, Vi',
          gender: 'Female'
        }
      },
      mangalDosha: {
        has_dosha: false,
        description: 'No Mangal Dosha is present. Mars is not positioned in the 1st, 4th, 7th, 8th, or 12th house from Lagna, Moon, or Venus. This indicates a harmonious marital life without the typical Manglik challenges.',
        remedies: [
          '🪔  Recite the Hanuman Chalisa daily, especially on Tuesdays',
          '💍  Wear a Red Coral (Moonga) gemstone after consulting a qualified astrologer',
          '🙏  Offer red flowers, sindoor, and jaggery to Lord Hanuman every Tuesday'
        ]
      },
      yogaDetails: [
        {
          name: 'Raja Yogas',
          yoga_list: [
            { name: 'Gaja-Kesari Yoga', has_yoga: true, description: 'Jupiter in a Kendra from the Moon. This yoga bestows wisdom, wealth, fame, and a regal status.' },
            { name: 'Dhana Yoga', has_yoga: true, description: 'Lords of the 2nd and 11th houses are in a Kendra. This yoga indicates financial prosperity.' },
            { name: 'Viparita Raja Yoga', has_yoga: false, description: 'Lords of the 6th, 8th, or 12th houses in their own or exaltation signs.' }
          ]
        },
        {
          name: 'Dhana Yogas',
          yoga_list: [
            { name: 'Adhi Yoga', has_yoga: true, description: 'Benefics in the 6th, 7th, and 8th from the Lagna. This yoga brings wealth and prosperity.' },
            { name: 'Lakshmi Yoga', has_yoga: true, description: 'Lord of the 9th in the Lagna or lord of the Lagna in the 9th. This yoga bestows affluence.' },
            { name: 'Parijata Yoga', has_yoga: false, description: 'The lord of the Lagna and the 5th house are in a Kendra.' }
          ]
        },
        {
          name: 'Sanyasa Yogas',
          yoga_list: [
            { name: 'Shravana Yoga', has_yoga: true, description: 'Three or more planets in the 10th from the Lagna. Indicates spiritual inclination.' },
            { name: 'Chaturashrama Yoga', has_yoga: false, description: 'Four or more planets in Kendra houses.' }
          ]
        }
      ],
      dashaPeriods: [
        { name: 'Venus', start: '2026-01-15', end: '2032-01-15', antardasha: [
          { name: 'Sun', start: '2026-01-15', end: '2026-07-15' },
          { name: 'Moon', start: '2026-07-15', end: '2027-07-15' },
          { name: 'Mars', start: '2027-07-15', end: '2028-01-15' },
          { name: 'Rahu', start: '2028-01-15', end: '2028-07-15' },
          { name: 'Jupiter', start: '2028-07-15', end: '2029-07-15' }
        ]},
        { name: 'Sun', start: '2032-01-15', end: '2038-07-15', antardasha: [
          { name: 'Moon', start: '2032-01-15', end: '2032-07-15' },
          { name: 'Mars', start: '2032-07-15', end: '2033-01-15' },
          { name: 'Rahu', start: '2033-01-15', end: '2033-07-15' }
        ]},
        { name: 'Moon', start: '2038-07-15', end: '2048-07-15', antardasha: [] },
        { name: 'Mars', start: '2048-07-15', end: '2055-01-15', antardasha: [] }
      ],
      dashaBalance: {
        lord: { name: 'Venus' },
        description: 'Venus Mahadasha 16 years 0 months — remaining 9 years 6 months'
      },
      planets: [
        { name: 'Sun', house: 5, degree: 12.3, minute: 45, is_retrograde: false, zodiac: { name: 'Simha' }, rasi: { name: 'Simha', lord: { name: 'Sun', vedic_name: 'Surya' } }, nakshatra: { name: 'Magha', pada: 1, lord: { name: 'Ketu' } } },
        { name: 'Moon', house: 2, degree: 22.1, minute: 30, is_retrograde: false, zodiac: { name: 'Vrishabha' }, rasi: { name: 'Vrishabha', lord: { name: 'Venus', vedic_name: 'Shukra' } }, nakshatra: { name: 'Rohini', pada: 3, lord: { name: 'Moon' } } },
        { name: 'Mars', house: 9, degree: 5.8, minute: 0, is_retrograde: false, zodiac: { name: 'Dhanu' }, rasi: { name: 'Dhanu', lord: { name: 'Jupiter', vedic_name: 'Guru' } }, nakshatra: { name: 'Moola', pada: 1, lord: { name: 'Ketu' } } },
        { name: 'Mercury', house: 5, degree: 28.5, minute: 15, is_retrograde: false, zodiac: { name: 'Simha' }, rasi: { name: 'Simha', lord: { name: 'Sun', vedic_name: 'Surya' } }, nakshatra: { name: 'UttaraPhalguni', pada: 1, lord: { name: 'Sun' } } },
        { name: 'Jupiter', house: 11, degree: 18.4, minute: 20, is_retrograde: false, zodiac: { name: 'Meena' }, rasi: { name: 'Meena', lord: { name: 'Jupiter', vedic_name: 'Guru' } }, nakshatra: { name: 'Revati', pada: 4, lord: { name: 'Mercury' } } },
        { name: 'Venus', house: 3, degree: 7.2, minute: 50, is_retrograde: false, zodiac: { name: 'Mithuna' }, rasi: { name: 'Mithuna', lord: { name: 'Mercury', vedic_name: 'Budha' } }, nakshatra: { name: 'Ardra', pada: 1, lord: { name: 'Rahu' } } },
        { name: 'Saturn', house: 12, degree: 14.9, minute: 10, is_retrograde: true, zodiac: { name: 'Kumbha' }, rasi: { name: 'Kumbha', lord: { name: 'Saturn', vedic_name: 'Shani' } }, nakshatra: { name: 'Shatabhisha', pada: 3, lord: { name: 'Rahu' } } },
        { name: 'Rahu', house: 7, degree: 3.6, minute: 40, is_retrograde: true, zodiac: { name: 'Tula' }, rasi: { name: 'Tula', lord: { name: 'Venus', vedic_name: 'Shukra' } }, nakshatra: { name: 'Chitra', pada: 2, lord: { name: 'Mars' } } },
        { name: 'Ketu', house: 1, degree: 3.6, minute: 40, is_retrograde: true, zodiac: { name: 'Mesha' }, rasi: { name: 'Mesha', lord: { name: 'Mars', vedic_name: 'Mangal' } }, nakshatra: { name: 'Ashwini', pada: 2, lord: { name: 'Ketu' } } }
      ],
      houses: [
        { house: 1, zodiac: { name: 'Simha' }, planets: [{ planet: { name: 'Ketu', is_retrograde: true } }] },
        { house: 2, zodiac: { name: 'Kanya' }, planets: [{ planet: { name: 'Moon' } }] },
        { house: 3, zodiac: { name: 'Tula' }, planets: [{ planet: { name: 'Venus' } }] },
        { house: 4, zodiac: { name: 'Vrischika' }, planets: [] },
        { house: 5, zodiac: { name: 'Dhanu' }, planets: [{ planet: { name: 'Sun' } }, { planet: { name: 'Mercury' } }] },
        { house: 6, zodiac: { name: 'Makara' }, planets: [] },
        { house: 7, zodiac: { name: 'Kumbha' }, planets: [{ planet: { name: 'Rahu', is_retrograde: true } }] },
        { house: 8, zodiac: { name: 'Meena' }, planets: [] },
        { house: 9, zodiac: { name: 'Mesha' }, planets: [{ planet: { name: 'Mars' } }] },
        { house: 10, zodiac: { name: 'Vrishabha' }, planets: [] },
        { house: 11, zodiac: { name: 'Mithuna' }, planets: [{ planet: { name: 'Jupiter' } }] },
        { house: 12, zodiac: { name: 'Karka' }, planets: [{ planet: { name: 'Saturn', is_retrograde: true } }] }
      ],
      chartSvg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 300" width="300" height="300"><rect width="300" height="300" fill="#faf6f0" rx="8"/><line x1="150" y1="0" x2="150" y2="300" stroke="#d4af37" stroke-width="0.5" opacity="0.3"/><line x1="0" y1="150" x2="300" y2="150" stroke="#d4af37" stroke-width="0.5" opacity="0.3"/><line x1="0" y1="0" x2="300" y2="300" stroke="#d4af37" stroke-width="0.5" opacity="0.2"/><line x1="300" y1="0" x2="0" y2="300" stroke="#d4af37" stroke-width="0.5" opacity="0.2"/><!-- Outer 12 houses --><rect x="10" y="10" width="80" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="30" y="50" font-size="10" fill="#444">1</text><text x="50" y="50" font-size="8" fill="#C89B3C">♌</text><rect x="100" y="10" width="90" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="120" y="50" font-size="10" fill="#444">2</text><text x="140" y="50" font-size="8" fill="#C89B3C">♍</text><rect x="200" y="10" width="90" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="220" y="50" font-size="10" fill="#444">3</text><text x="240" y="50" font-size="8" fill="#C89B3C">♎</text><rect x="10" y="85" width="80" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="30" y="115" font-size="10" fill="#444">4</text><text x="50" y="115" font-size="8" fill="#C89B3C">♏</text><rect x="100" y="85" width="90" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="120" y="115" font-size="10" fill="#444">5</text><text x="140" y="115" font-size="8" fill="#C89B3C">♐</text><rect x="200" y="85" width="90" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="220" y="115" font-size="10" fill="#444">6</text><text x="240" y="115" font-size="8" fill="#C89B3C">♑</text><rect x="10" y="160" width="80" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="30" y="190" font-size="10" fill="#444">7</text><text x="50" y="190" font-size="8" fill="#C89B3C">♒</text><rect x="100" y="160" width="90" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="120" y="190" font-size="10" fill="#444">8</text><text x="140" y="190" font-size="8" fill="#C89B3C">♓</text><rect x="200" y="160" width="90" height="65" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="220" y="190" font-size="10" fill="#444">9</text><text x="240" y="190" font-size="8" fill="#C89B3C">♈</text><rect x="10" y="235" width="80" height="55" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="30" y="260" font-size="10" fill="#444">10</text><text x="50" y="260" font-size="8" fill="#C89B3C">♉</text><rect x="100" y="235" width="90" height="55" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="120" y="260" font-size="10" fill="#444">11</text><text x="140" y="260" font-size="8" fill="#C89B3C">♊</text><rect x="200" y="235" width="90" height="55" fill="none" stroke="#8B4513" stroke-width="1.5" rx="4"/><text x="220" y="260" font-size="10" fill="#444">12</text><text x="240" y="260" font-size="8" fill="#C89B3C">♋</text><text x="10" y="150" font-size="7" fill="#C89B3C" transform="rotate(-90,10,150)">South Indian</text></svg>',
      chartSvgNorth: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 280" width="300" height="280"><rect width="300" height="280" fill="#faf6f0" rx="8"/><line x1="75" y1="0" x2="75" y2="280" stroke="#d4af37" stroke-width="0.5" opacity="0.3"/><line x1="225" y1="0" x2="225" y2="280" stroke="#d4af37" stroke-width="0.5" opacity="0.3"/><line x1="0" y1="70" x2="300" y2="70" stroke="#d4af37" stroke-width="0.5" opacity="0.3"/><line x1="0" y1="210" x2="300" y2="210" stroke="#d4af37" stroke-width="0.5" opacity="0.3"/><!-- Row 1: empty, house 10, house 9, empty --><rect x="77" y="2" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="95" y="40" font-size="9" fill="#444">10</text><text x="115" y="40" font-size="7" fill="#C89B3C">♉</text><rect x="149" y="2" width="72" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="167" y="40" font-size="9" fill="#444">9</text><text x="187" y="40" font-size="7" fill="#C89B3C">♈</text><!-- Row 2: house 11, house 2, house 1, house 8 --><rect x="2" y="72" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="20" y="110" font-size="9" fill="#444">11</text><text x="40" y="110" font-size="7" fill="#C89B3C">♊</text><rect x="77" y="72" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="95" y="110" font-size="9" fill="#444">2</text><text x="115" y="110" font-size="7" fill="#C89B3C">♍</text><rect x="149" y="72" width="72" height="66" fill="none" stroke="#C89B3C" stroke-width="2" rx="3"/><text x="167" y="110" font-size="9" fill="#C89B3C">1</text><text x="187" y="110" font-size="7" fill="#C89B3C">♌</text><text x="170" y="125" font-size="6" fill="#C89B3C">ASC</text><rect x="225" y="72" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="243" y="110" font-size="9" fill="#444">8</text><text x="263" y="110" font-size="7" fill="#C89B3C">♓</text><!-- Row 3: house 5, house 3, house 12, house 7 --><rect x="2" y="142" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="20" y="180" font-size="9" fill="#444">5</text><text x="40" y="180" font-size="7" fill="#C89B3C">♐</text><rect x="77" y="142" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="95" y="180" font-size="9" fill="#444">3</text><text x="115" y="180" font-size="7" fill="#C89B3C">♎</text><rect x="149" y="142" width="72" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="167" y="180" font-size="9" fill="#444">12</text><text x="187" y="180" font-size="7" fill="#C89B3C">♋</text><rect x="225" y="142" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="243" y="180" font-size="9" fill="#444">7</text><text x="263" y="180" font-size="7" fill="#C89B3C">♒</text><!-- Row 4: empty, house 4, house 6, empty --><rect x="77" y="212" width="70" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="95" y="248" font-size="9" fill="#444">4</text><text x="115" y="248" font-size="7" fill="#C89B3C">♏</text><rect x="149" y="212" width="72" height="66" fill="none" stroke="#8B4513" stroke-width="1.5" rx="3"/><text x="167" y="248" font-size="9" fill="#444">6</text><text x="187" y="248" font-size="7" fill="#C89B3C">♑</text><text x="10" y="160" font-size="7" fill="#C89B3C" transform="rotate(-90,10,160)">North Indian</text></svg>',
      planetPositions: { planet_position: [
        { name: 'Sun', degree: 12.3, position: 5, is_retrograde: false, rasi: { name: 'Simha', lord: { name: 'Sun', vedic_name: 'Surya' } }, nakshatra: { name: 'Magha' } },
        { name: 'Moon', degree: 22.1, position: 2, is_retrograde: false, rasi: { name: 'Vrishabha', lord: { name: 'Venus', vedic_name: 'Shukra' } }, nakshatra: { name: 'Rohini' } },
        { name: 'Mars', degree: 5.8, position: 9, is_retrograde: false, rasi: { name: 'Dhanu', lord: { name: 'Jupiter', vedic_name: 'Guru' } }, nakshatra: { name: 'Moola' } },
        { name: 'Mercury', degree: 28.5, position: 5, is_retrograde: false, rasi: { name: 'Simha', lord: { name: 'Sun', vedic_name: 'Surya' } }, nakshatra: { name: 'UttaraPhalguni' } },
        { name: 'Jupiter', degree: 18.4, position: 11, is_retrograde: false, rasi: { name: 'Meena', lord: { name: 'Jupiter', vedic_name: 'Guru' } }, nakshatra: { name: 'Revati' } },
        { name: 'Venus', degree: 7.2, position: 3, is_retrograde: false, rasi: { name: 'Mithuna', lord: { name: 'Mercury', vedic_name: 'Budha' } }, nakshatra: { name: 'Ardra' } },
        { name: 'Saturn', degree: 14.9, position: 12, is_retrograde: true, rasi: { name: 'Kumbha', lord: { name: 'Saturn', vedic_name: 'Shani' } }, nakshatra: { name: 'Shatabhisha' } },
        { name: 'Rahu', degree: 3.6, position: 7, is_retrograde: true, rasi: { name: 'Tula', lord: { name: 'Venus', vedic_name: 'Shukra' } }, nakshatra: { name: 'Chitra' } },
        { name: 'Ketu', degree: 3.6, position: 1, is_retrograde: true, rasi: { name: 'Mesha', lord: { name: 'Mars', vedic_name: 'Mangal' } }, nakshatra: { name: 'Ashwini' } }
      ] }
    };
  }

  var PLANET_SYMBOLS = {
    'Sun': '☉', 'Moon': '☽', 'Mars': '♂', 'Mercury': '☿',
    'Jupiter': '♃', 'Venus': '♀', 'Saturn': '♄',
    'Rahu': '☊', 'Ketu': '☋'
  };

  // ===== PARTICLES =====
  function initParticles() {
    var canvas = document.getElementById('kundliParticleCanvas');
    if (!canvas) {
      canvas = document.createElement('canvas');
      canvas.id = 'kundliParticleCanvas';
      document.body.appendChild(canvas);
    }
    var ctx = canvas.getContext('2d');
    var w, h, particles = [];

    function resize() { w = canvas.width = window.innerWidth; h = canvas.height = window.innerHeight; }
    resize();
    window.addEventListener('resize', resize);

    for (var i = 0; i < 50; i++) {
      particles.push({
        x: Math.random() * w, y: Math.random() * h,
        r: Math.random() * 2 + 0.5,
        dx: (Math.random() - 0.5) * 0.3, dy: (Math.random() - 0.5) * 0.3,
        alpha: Math.random() * 0.5 + 0.2
      });
    }

    function animate() {
      ctx.clearRect(0, 0, w, h);
      particles.forEach(function(p) {
        p.x += p.dx; p.y += p.dy;
        if (p.x < 0) p.x = w; if (p.x > w) p.x = 0;
        if (p.y < 0) p.y = h; if (p.y > h) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(192, 57, 43, ' + p.alpha + ')';
        ctx.fill();
      });
      requestAnimationFrame(animate);
    }
    animate();
  }

  // ===== GENDER =====
  var selectedGender = 'male';
  document.querySelectorAll('#genderMale-' + sId + ', #genderFemale-' + sId).forEach(function(btn) {
    btn.addEventListener('click', function() {
      document.querySelectorAll('#genderMale-' + sId + ', #genderFemale-' + sId).forEach(function(b) { b.classList.remove('selected'); });
      this.classList.add('selected');
      selectedGender = this.getAttribute('data-gender');
    });
  });

  // ===== CURRENT TIME =====
  document.getElementById('useCurrentTime-' + sId).addEventListener('click', function() {
    var now = new Date();
    document.getElementById('personTob-' + sId).value = String(now.getHours()).padStart(2,'0') + ':' + String(now.getMinutes()).padStart(2,'0');
  });

  // ==============================================================
  //  TIMEZONE — resolved from the BIRTHPLACE, never from this browser
  //
  //  The old code pre-selected the zone from -new Date().getTimezoneOffset(),
  //  i.e. from where the customer is sitting right now. A customer in Dubai
  //  entering a Delhi birth got +04:00 and a silently wrong ascendant — the
  //  chart looked perfectly normal and was an hour and a half out.
  //
  //  Nominatim already returns the country on every autocomplete hit, so the
  //  zone comes from the place instead. Most countries keep exactly one zone
  //  and resolve outright; the wide ones need the coordinates as well. When
  //  neither settles it the customer's own choice stands, which is why this
  //  stays a visible, editable field rather than a hidden one.
  // ==============================================================

  // Countries that keep a single IANA zone. China is here deliberately: it
  // spans five geographic hours and observes one.
  var COUNTRY_ZONES = {
    in:'Asia/Kolkata', np:'Asia/Kathmandu', bd:'Asia/Dhaka', pk:'Asia/Karachi',
    lk:'Asia/Colombo', bt:'Asia/Thimphu', mv:'Indian/Maldives', mm:'Asia/Yangon',
    af:'Asia/Kabul', ir:'Asia/Tehran', iq:'Asia/Baghdad', ae:'Asia/Dubai',
    sa:'Asia/Riyadh', qa:'Asia/Qatar', kw:'Asia/Kuwait', om:'Asia/Muscat',
    bh:'Asia/Bahrain', ye:'Asia/Aden', jo:'Asia/Amman', lb:'Asia/Beirut',
    sy:'Asia/Damascus', il:'Asia/Jerusalem', tr:'Europe/Istanbul',
    ge:'Asia/Tbilisi', am:'Asia/Yerevan', az:'Asia/Baku', uz:'Asia/Tashkent',
    tm:'Asia/Ashgabat', tj:'Asia/Dushanbe', kg:'Asia/Bishkek',
    cn:'Asia/Shanghai', hk:'Asia/Hong_Kong', mo:'Asia/Macau', tw:'Asia/Taipei',
    jp:'Asia/Tokyo', kr:'Asia/Seoul', kp:'Asia/Pyongyang', mn:'Asia/Ulaanbaatar',
    sg:'Asia/Singapore', my:'Asia/Kuala_Lumpur', th:'Asia/Bangkok',
    vn:'Asia/Ho_Chi_Minh', kh:'Asia/Phnom_Penh', la:'Asia/Vientiane',
    ph:'Asia/Manila', bn:'Asia/Brunei', np_:'Asia/Kathmandu',
    gb:'Europe/London', ie:'Europe/Dublin', is:'Atlantic/Reykjavik',
    fr:'Europe/Paris', de:'Europe/Berlin', nl:'Europe/Amsterdam',
    be:'Europe/Brussels', lu:'Europe/Luxembourg', ch:'Europe/Zurich',
    at:'Europe/Vienna', it:'Europe/Rome', mt:'Europe/Malta',
    dk:'Europe/Copenhagen', no:'Europe/Oslo', se:'Europe/Stockholm',
    fi:'Europe/Helsinki', ee:'Europe/Tallinn', lv:'Europe/Riga',
    lt:'Europe/Vilnius', pl:'Europe/Warsaw', cz:'Europe/Prague',
    sk:'Europe/Bratislava', hu:'Europe/Budapest', si:'Europe/Ljubljana',
    hr:'Europe/Zagreb', ba:'Europe/Sarajevo', rs:'Europe/Belgrade',
    me:'Europe/Podgorica', mk:'Europe/Skopje', al:'Europe/Tirane',
    gr:'Europe/Athens', bg:'Europe/Sofia', ro:'Europe/Bucharest',
    md:'Europe/Chisinau', ua:'Europe/Kyiv', by:'Europe/Minsk',
    cy:'Asia/Nicosia',
    eg:'Africa/Cairo', ly:'Africa/Tripoli', tn:'Africa/Tunis',
    dz:'Africa/Algiers', ma:'Africa/Casablanca', sd:'Africa/Khartoum',
    et:'Africa/Addis_Ababa', ke:'Africa/Nairobi', tz:'Africa/Dar_es_Salaam',
    ug:'Africa/Kampala', rw:'Africa/Kigali', ng:'Africa/Lagos',
    gh:'Africa/Accra', ci:'Africa/Abidjan', sn:'Africa/Dakar',
    cm:'Africa/Douala', za:'Africa/Johannesburg', zw:'Africa/Harare',
    zm:'Africa/Lusaka', mw:'Africa/Blantyre', mz:'Africa/Maputo',
    bw:'Africa/Gaborone', na:'Africa/Windhoek', mu:'Indian/Mauritius',
    sc:'Indian/Mahe', re:'Indian/Reunion',
    ar:'America/Argentina/Buenos_Aires', uy:'America/Montevideo',
    py:'America/Asuncion', bo:'America/La_Paz', pe:'America/Lima',
    co:'America/Bogota', ve:'America/Caracas', gy:'America/Guyana',
    sr:'America/Paramaribo', pa:'America/Panama', cr:'America/Costa_Rica',
    ni:'America/Managua', hn:'America/Tegucigalpa', sv:'America/El_Salvador',
    gt:'America/Guatemala', bz:'America/Belize', cu:'America/Havana',
    jm:'America/Jamaica', ht:'America/Port-au-Prince',
    do:'America/Santo_Domingo', pr:'America/Puerto_Rico',
    tt:'America/Port_of_Spain', bb:'America/Barbados', bs:'America/Nassau',
    fj:'Pacific/Fiji', pg:'Pacific/Port_Moresby', ws:'Pacific/Apia',
    to:'Pacific/Tongatapu', vu:'Pacific/Efate', nc:'Pacific/Noumea'
  };

  // Countries wide enough to hold several zones. Each returns the zone for a
  // coordinate; the boundaries are approximations of the real, ragged ones, so
  // a birth within a few tens of kilometres of a border may need the manual
  // override — which is exactly why the field stays editable.
  var MULTI_ZONE_COUNTRIES = {
    us: function(lat, lon) {
      if (lat > 51 && lon < -129) return 'America/Anchorage';
      if (lat < 25 && lon < -150) return 'Pacific/Honolulu';
      // Most of Arizona keeps mountain time without the summer shift.
      if (lat > 31 && lat < 37.1 && lon > -115 && lon < -109) return 'America/Phoenix';
      if (lon >= -85) return 'America/New_York';
      if (lon >= -100.5) return 'America/Chicago';
      if (lon >= -114) return 'America/Denver';
      return 'America/Los_Angeles';
    },
    ca: function(lat, lon) {
      if (lon >= -57.5 && lat >= 46.5) return 'America/St_Johns';
      if (lon >= -63) return 'America/Halifax';
      if (lon >= -90) return 'America/Toronto';
      if (lon >= -102) return 'America/Winnipeg';
      if (lon >= -120) return 'America/Edmonton';
      return 'America/Vancouver';
    },
    au: function(lat, lon) {
      if (lon < 129) return 'Australia/Perth';
      if (lon < 138) return lat > -26 ? 'Australia/Darwin' : 'Australia/Adelaide';
      if (lat > -29) return 'Australia/Brisbane';
      return 'Australia/Sydney';
    },
    ru: function(lat, lon) {
      if (lon < 22) return 'Europe/Kaliningrad';
      if (lon < 45) return 'Europe/Moscow';
      if (lon < 55) return 'Europe/Samara';
      if (lon < 67) return 'Asia/Yekaterinburg';
      if (lon < 78) return 'Asia/Omsk';
      if (lon < 92) return 'Asia/Krasnoyarsk';
      if (lon < 108) return 'Asia/Irkutsk';
      if (lon < 120) return 'Asia/Chita';
      if (lon < 137) return 'Asia/Yakutsk';
      if (lon < 147) return 'Asia/Vladivostok';
      if (lon < 160) return 'Asia/Magadan';
      return 'Asia/Kamchatka';
    },
    br: function(lat, lon) {
      if (lon < -70) return 'America/Rio_Branco';
      if (lon < -57) return 'America/Manaus';
      if (lon > -34 && lat > -5) return 'America/Noronha';
      return 'America/Sao_Paulo';
    },
    mx: function(lat, lon) {
      if (lon < -110) return 'America/Tijuana';
      if (lon < -103) return 'America/Mazatlan';
      return 'America/Mexico_City';
    },
    id: function(lat, lon) {
      if (lon < 112.5) return 'Asia/Jakarta';
      if (lon < 127.5) return 'Asia/Makassar';
      return 'Asia/Jayapura';
    },
    kz: function(lat, lon) { return lon < 68 ? 'Asia/Aqtobe' : 'Asia/Almaty'; },
    cl: function(lat, lon) { return lon < -85 ? 'Pacific/Easter' : 'America/Santiago'; },
    ec: function(lat, lon) { return lon < -85 ? 'Pacific/Galapagos' : 'America/Guayaquil'; },
    es: function(lat, lon) { return lon < -12 ? 'Atlantic/Canary' : 'Europe/Madrid'; },
    pt: function(lat, lon) { return lon < -20 ? 'Atlantic/Azores' : 'Europe/Lisbon'; },
    cd: function(lat, lon) { return lon < 25 ? 'Africa/Kinshasa' : 'Africa/Lubumbashi'; },
    nz: function(lat, lon) { return lon < -176 ? 'Pacific/Chatham' : 'Pacific/Auckland'; }
  };

  // resolveZone returns the IANA zone for a place, or null when the country is
  // one this table does not cover. Null means "leave the customer's choice
  // alone" — never "guess".
  function resolveZone(countryCode, lat, lon) {
    if (!countryCode) return null;
    var cc = String(countryCode).toLowerCase();
    var la = parseFloat(lat), lo = parseFloat(lon);
    if (MULTI_ZONE_COUNTRIES[cc] && isFinite(la) && isFinite(lo)) {
      return MULTI_ZONE_COUNTRIES[cc](la, lo);
    }
    return COUNTRY_ZONES[cc] || null;
  }

  // applyZone selects a zone in the dropdown, adding the option when the zone
  // is one the curated list does not carry. The select stays the single source
  // of truth, so what the customer sees is exactly what gets sent.
  function applyZone(zone) {
    if (!zone) return false;
    var select = document.getElementById('personTz-' + sId);
    if (!select) return false;
    var found = -1;
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].value === zone) { found = i; break; }
    }
    if (found === -1) {
      var opt = document.createElement('option');
      opt.value = zone;
      opt.textContent = '🌍 ' + zone.replace(/_/g, ' ');
      select.appendChild(opt);
      found = select.options.length - 1;
    }
    select.selectedIndex = found;
    var note = document.getElementById('tzResolved-' + sId);
    if (note) {
      note.textContent = '🕓 Set from birthplace: ' + zone;
      note.style.display = 'inline';
    }
    return true;
  }

  // Nominatim nests the country code under address when addressdetails=1 is
  // asked for, and omits it otherwise.
  function countryCodeOf(place) {
    if (!place) return null;
    if (place.address && place.address.country_code) return place.address.country_code;
    return place.country_code || null;
  }

  // ===== DETECT LOCATION =====
  document.getElementById('detectLocation-' + sId).addEventListener('click', function() {
    var btn = this;
    if (!navigator.geolocation) { alert('Geolocation not supported.'); return; }
    btn.classList.add('loading');
    navigator.geolocation.getCurrentPosition(function(pos) {
      btn.classList.remove('loading');
      var lat = pos.coords.latitude, lon = pos.coords.longitude;
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat=' + lat + '&lon=' + lon + '&addressdetails=1', { headers: { 'Accept-Language': 'en' } })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var place = data.display_name || (lat.toFixed(4) + ', ' + lon.toFixed(4));
        var input = document.getElementById('personPlace-' + sId);
        input.value = place.split(', ').slice(0, 3).join(', ');
        input.dataset.lat = lat; input.dataset.lon = lon;
        input.dataset.cc = countryCodeOf(data) || '';
        applyZone(resolveZone(input.dataset.cc, lat, lon));
        var coordsEl = document.getElementById('placeCoords-' + sId);
        if (coordsEl) { coordsEl.textContent = '📍 ' + lat.toFixed(4) + ', ' + lon.toFixed(4); coordsEl.style.display = 'inline'; }
      })
      .catch(function() {
        document.getElementById('personPlace-' + sId).value = lat.toFixed(4) + ', ' + lon.toFixed(4);
        document.getElementById('personPlace-' + sId).dataset.lat = lat;
        document.getElementById('personPlace-' + sId).dataset.lon = lon;
      });
    }, function() { btn.classList.remove('loading'); alert('Could not detect location.'); }, { enableHighAccuracy: true, timeout: 10000 });
  });

  // ===== AUTOCOMPLETE =====
  var acTimeout = null;
  function setupAutocomplete(inputId, listId) {
    var input = document.getElementById(inputId);
    var list = document.getElementById(listId);
    var coordsEl = document.getElementById('placeCoords-' + sId);
    input.addEventListener('input', function() {
      var query = this.value.trim();
      if (query.length < 2) { list.classList.remove('visible'); list.innerHTML = ''; if (coordsEl) coordsEl.style.display = 'none'; return; }
      clearTimeout(acTimeout);
      acTimeout = setTimeout(function() {
        fetch('https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(query) + '&limit=6&addressdetails=1', { headers: { 'Accept-Language': 'en' } })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          list.innerHTML = '';
          if (data && data.length > 0) {
            data.forEach(function(place) {
              var item = document.createElement('div');
              item.className = 'place-autocomplete-item';
              var parts = (place.display_name || place.name || '').split(', ');
              item.innerHTML = '<span class="place-name">' + (place.name || parts[0] || '') + '</span><span class="place-region"> ' + (parts.length > 1 ? parts.slice(1, 3).join(', ') : '') + '</span>';
              item.addEventListener('click', function() {
                input.value = place.display_name || place.name || '';
                input.dataset.lat = place.lat; input.dataset.lon = place.lon;
                input.dataset.cc = countryCodeOf(place) || '';
                // The zone belongs to the birthplace, so it is set here rather
                // than left on whatever the customer's own clock suggested.
                applyZone(resolveZone(input.dataset.cc, place.lat, place.lon));
                if (coordsEl) { coordsEl.textContent = '📍 ' + parseFloat(place.lat).toFixed(4) + ', ' + parseFloat(place.lon).toFixed(4); coordsEl.style.display = 'inline'; }
                list.classList.remove('visible'); list.innerHTML = '';
              });
              list.appendChild(item);
            });
            list.classList.add('visible');
          } else {
            list.innerHTML = '<div class="place-autocomplete-no-results">No places found.</div>'; list.classList.add('visible');
          }
        }).catch(function() {});
      }, 400);
    });
    input.addEventListener('blur', function() { setTimeout(function() { list.classList.remove('visible'); }, 200); });
    input.addEventListener('focus', function() { if (list.children.length > 0) list.classList.add('visible'); });
    input.addEventListener('keydown', function(e) {
      var items = list.querySelectorAll('.place-autocomplete-item');
      var active = list.querySelector('.place-autocomplete-item.active');
      var idx = -1; if (active) idx = Array.prototype.indexOf.call(items, active);
      if (e.key === 'ArrowDown') { e.preventDefault(); if (active) active.classList.remove('active'); var next = Math.min(idx + 1, items.length - 1); if (next >= 0 && items[next]) items[next].classList.add('active'); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (active) active.classList.remove('active'); var prev = Math.max(idx - 1, 0); if (prev >= 0 && items[prev]) items[prev].classList.add('active'); }
      else if (e.key === 'Enter') { if (active) { e.preventDefault(); active.click(); } }
      else if (e.key === 'Escape') { list.classList.remove('visible'); }
    });
  }
  setupAutocomplete('personPlace-' + sId, 'personPlaceList-' + sId);

  // ===== FORM HELPERS =====
  function setFieldError(inputId, errorId, show) {
    var input = document.getElementById(inputId);
    var error = document.getElementById(errorId);
    if (show) { input.classList.add('error'); error.classList.add('visible'); } else { input.classList.remove('error'); error.classList.remove('visible'); }
  }
  function validateForm() {
    var valid = true;
    [ { input: 'personName-' + sId, error: 'personNameError-' + sId },
      { input: 'personDob-' + sId, error: 'personDobError-' + sId },
      { input: 'personTob-' + sId, error: 'personTobError-' + sId },
      { input: 'personPlace-' + sId, error: 'personPlaceError-' + sId } ]
    .forEach(function(f) {
      var val = document.getElementById(f.input).value.trim();
      if (!val) { setFieldError(f.input, f.error, true); valid = false; } else { setFieldError(f.input, f.error, false); }
    });
    return valid;
  }
  function getFormData() {
    var dob = document.getElementById('personDob-' + sId).value;
    var tob = document.getElementById('personTob-' + sId).value;
    var placeInput = document.getElementById('personPlace-' + sId);
    return {
      name: document.getElementById('personName-' + sId).value.trim(),
      gender: selectedGender,
      dob: dob,
      tob: tob,
      timezone: document.getElementById('personTz-' + sId).value,
      countryCode: placeInput.dataset.cc || '',
      place: placeInput.value.trim(),
      latitude: placeInput.dataset.lat || '',
      longitude: placeInput.dataset.lon || '',
      date: dob,
      time: tob + ':00'
    };
  }

  // buildBirthRecord is the one place that speaks the astrology API's shape.
  // Every request that reaches the engine — first attempt, retry after a
  // recovered payment — goes through here, so the three call sites cannot
  // drift apart and send subtly different charts for the same person.
  //
  // The names are the API's own: birthDate/birthTime as separate local civil
  // fields and an IANA timezone, rather than one datetime string with an
  // offset glued on the end. The engine applies the zone rules in force on the
  // birth date, which a fixed offset cannot express.
  function buildBirthRecord(formData) {
    return {
      name: formData.name,
      gender: formData.gender,
      birthDate: formData.dob,
      birthTime: formData.tob,
      latitude: parseFloat(formData.latitude),
      longitude: parseFloat(formData.longitude),
      timezone: normaliseZone(formData.timezone),
      place: formData.place
    };
  }

  // A recovered payment replays form data saved before this page stored IANA
  // names, so it can still carry "+05:30". Rather than fail that customer's
  // retry on a validation error they cannot act on, translate the offsets this
  // page used to offer. Anything else falls back to the current selection.
  var LEGACY_OFFSET_ZONES = {
    '+05:30':'Asia/Kolkata', '+05:45':'Asia/Kathmandu', '+04:00':'Asia/Dubai',
    '+00:00':'Europe/London', '-05:00':'America/New_York', '-08:00':'America/Los_Angeles',
    '+08:00':'Asia/Shanghai', '+09:00':'Asia/Tokyo', '+10:00':'Australia/Brisbane',
    '+01:00':'Europe/Berlin', '+02:00':'Europe/Athens', '+03:00':'Asia/Riyadh',
    '+06:00':'Asia/Dhaka', '+07:00':'Asia/Bangkok', '-10:00':'Pacific/Honolulu'
  };
  function normaliseZone(tz) {
    if (tz && tz.indexOf('/') !== -1) return tz;
    if (tz && LEGACY_OFFSET_ZONES[tz]) return LEGACY_OFFSET_ZONES[tz];
    var select = document.getElementById('personTz-' + sId);
    return (select && select.value) || 'Asia/Kolkata';
  }
  function formatDate(d) { if (!d) return '—'; var dt = new Date(d + 'T12:00:00'); return dt.toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric' }); }
  function formatTime(t) { if (!t) return '—'; var p = t.split(':'); var h = parseInt(p[0]); var ampm = h >= 12 ? 'PM' : 'AM'; h = h % 12 || 12; return h + ':' + p[1] + ' ' + ampm; }

  // ===== STEPS =====
  function setStep(step) {
    for (var i = 1; i <= 3; i++) {
      var el = document.getElementById('step' + i + '-' + sId);
      el.classList.remove('active', 'completed');
      if (i < step) el.classList.add('completed'); else if (i === step) el.classList.add('active');
    }
    for (var i = 1; i <= 2; i++) {
      var conn = document.getElementById('conn' + i + '-' + sId);
      if (conn) { if (i < step) conn.classList.add('completed'); else conn.classList.remove('completed'); }
    }
  }

  // ===== TABS =====
  function setupTabs() {
    document.querySelectorAll('#kundliTabs-' + sId + ' .kundli-tab').forEach(function(tab) {
      tab.addEventListener('click', function() {
        document.querySelectorAll('#kundliTabs-' + sId + ' .kundli-tab').forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
        document.querySelectorAll('#kundliResults-' + sId + ' .kundli-tab-content').forEach(function(c) { c.classList.remove('active'); });
        var targetEl = document.getElementById('tab-' + this.dataset.tab + '-' + sId);
        if (targetEl) targetEl.classList.add('active');
      });
    });
  }

  // ===== RENDER BADGES =====
  function renderBadges(rowId, data) {
    var row = document.getElementById(rowId);
    if (!row) return;
    row.innerHTML = '';
    var nakshatraName = data.nakshatra || '—';
    var rashiName = data.rashi || '—';
    var lagna = data.lagna || '—';
    var pada = data.pada || '—';
    [ { icon: '🔆', label: 'Lagna', value: lagna },
      { icon: '🌙', label: 'Rashi (Moon)', value: rashiName },
      { icon: '⭐', label: 'Nakshatra', value: nakshatraName },
      { icon: '🔯', label: 'Pada', value: pada } ]
    .forEach(function(b) {
      var badge = document.createElement('div');
      badge.className = 'kundli-badge';
      badge.innerHTML = '<span class="badge-icon">' + b.icon + '</span><span class="badge-label">' + b.label + ':</span> <span class="badge-value">' + b.value + '</span>';
      row.appendChild(badge);
    });
  }

  // ===== NAKSHATRA SUMMARY =====
  function renderNakshatraSummary(containerId, data) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var card = document.getElementById('nakshatraSummaryCard-' + sId);
    if (!card) return;
    card.style.display = 'block';

    var nd = data.rawNakshatra || {};
    var nakshatra = nd.nakshatra || {};
    var chandraRasi = nd.chandra_rasi || {};
    var sooryaRasi = nd.soorya_rasi || {};
    var zodiac = nd.zodiac || {};

    container.innerHTML =
      '<div class="nakshatra-summary-item"><span class="ns-label">Nakshatra</span><span class="ns-value">' + (nakshatra.name || '—') + '</span></div>' +
      '<div class="nakshatra-summary-item"><span class="ns-label">Pada</span><span class="ns-value">' + (nakshatra.pada || '—') + '</span></div>' +
      '<div class="nakshatra-summary-item"><span class="ns-label">Lord</span><span class="ns-value">' + (nakshatra.lord ? nakshatra.lord.name : '—') + '</span></div>' +
      '<div class="nakshatra-summary-item"><span class="ns-label">Chandra Rashi</span><span class="ns-value">' + (chandraRasi.name || '—') + '</span></div>' +
      '<div class="nakshatra-summary-item"><span class="ns-label">Soorya Rashi</span><span class="ns-value">' + (sooryaRasi.name || '—') + '</span></div>' +
      '<div class="nakshatra-summary-item"><span class="ns-label">Zodiac</span><span class="ns-value">' + (zodiac.name || '—') + '</span></div>';
  }

  // ===== NAKSHATRA INFO GRID =====
  function renderNakshatraInfo(gridId, data) {
    var grid = document.getElementById(gridId);
    if (!grid) return;
    var info = data.nakshatraInfo || null;
    if (!info) { grid.innerHTML = '<div style="text-align:center;opacity:0.5;padding:20px;">No additional nakshatra info available</div>'; return; }
    grid.innerHTML = '';
    // Rows with no value are skipped, so this list can carry more than any one
    // response supplies. The Avakhada block at the end is what a printed
    // kundli opens with, and the engine computes all of it.
    [ { icon: '🕉️', label: 'Deity', value: info.deity },
      { icon: '👥', label: 'Ganam', value: info.ganam },
      { icon: '🔣', label: 'Symbol', value: info.symbol },
      { icon: '🐄', label: 'Yoni', value: info.animal_sign },
      { icon: '💧', label: 'Nadi', value: info.nadi },
      { icon: '🎨', label: 'Color', value: info.color },
      { icon: '🧭', label: 'Direction', value: info.best_direction },
      { icon: '🔤', label: 'Syllables', value: info.syllables },
      { icon: '💎', label: 'Birth Stone', value: info.birth_stone },
      { icon: '🪐', label: 'Planet', value: info.planet },
      { icon: '⚔️', label: 'Varna', value: info.varna },
      { icon: '🧲', label: 'Vashya', value: info.vashya },
      { icon: '🜂', label: 'Tatva', value: info.tatva },
      { icon: '🪙', label: 'Paya', value: info.paya } ]
    .forEach(function(item) {
      if (!item.value || item.value === '—') return;
      var div = document.createElement('div');
      div.className = 'nakshatra-item';
      div.innerHTML = '<span class="n-item-icon">' + item.icon + '</span><div><span class="n-item-label">' + item.label + '</span><span class="n-item-value"> ' + item.value + '</span></div>';
      grid.appendChild(div);
    });
  }

  // ===== MANGAL DOSHA =====
  function renderMangalDosha(containerId, data) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var card = document.getElementById('mangalCard-' + sId);
    if (!card) return;
    var dosha = data.mangalDosha || null;
    if (!dosha) { card.style.display = 'none'; return; }
    card.style.display = 'block';
    var hasDosha = dosha.has_dosha === true;
    var html = '<div class="mangal-status ' + (hasDosha ? 'danger' : 'safe') + '">' +
      '<span class="mangal-icon">' + (hasDosha ? '🔥' : '✅') + '</span>' +
      '<div><div class="mangal-text">' + (hasDosha ? 'Manglik' : 'Not Manglik') + '</div>' +
      '<div class="mangal-desc">' + (dosha.description || '') + '</div></div></div>';
    if (dosha.remedies && dosha.remedies.length > 0) {
      html += '<div class="mangal-remedies"><h5>🪔 Suggested Remedies</h5><ul>';
      dosha.remedies.forEach(function(r) { html += '<li>' + r + '</li>'; });
      html += '</ul></div>';
    }
    container.innerHTML = html;
  }

  // ===== YOGA =====
  function renderYogaDetails(accordionId, data) {
    var accordion = document.getElementById(accordionId);
    if (!accordion) return;
    var card = document.getElementById('yogaCard-' + sId);
    if (!card) return;
    var yogas = data.yogaDetails || null;
    if (!yogas || yogas.length === 0) { card.style.display = 'none'; return; }
    card.style.display = 'block';
    accordion.innerHTML = '';
    yogas.forEach(function(category, idx) {
      var catDiv = document.createElement('div');
      catDiv.className = 'yoga-category';
      if (idx === 0) catDiv.classList.add('open');
      var total = (category.yoga_list || []).length;
      var present = (category.yoga_list || []).filter(function(y) { return y.has_yoga; }).length;
      catDiv.innerHTML =
        '<div class="yoga-category-header" data-cat="' + idx + '">' +
          '<div><span class="y-cat-name">' + (category.name || 'Yogas') + '</span> <span class="y-cat-count">(' + present + '/' + total + ')</span></div>' +
          '<span class="y-cat-arrow">▼</span></div>' +
        '<div class="yoga-list">' +
          ((category.yoga_list || []).map(function(y) {
            return '<div class="yoga-item">' +
              '<div class="yoga-name-row"><span class="yoga-status ' + (y.has_yoga ? 'present' : 'absent') + '">' + (y.has_yoga ? '✅' : '❌') + '</span>' +
              '<span class="yoga-name">' + (y.name || '—') + '</span></div>' +
              '<div class="yoga-desc">' + (y.description || '') + '</div></div>';
          }).join('')) +
        '</div>';
      accordion.appendChild(catDiv);
      catDiv.querySelector('.yoga-category-header').addEventListener('click', function() { catDiv.classList.toggle('open'); });
    });
  }

  // ===== DASHA BALANCE =====
  function renderDashaBalance(containerId, data) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var card = document.getElementById('dashaBalanceCard-' + sId);
    if (!card) return;
    var balance = data.dashaBalance || null;
    if (!balance) { card.style.display = 'none'; return; }
    card.style.display = 'block';
    var lord = balance.lord || {};
    var sym = PLANET_SYMBOLS[lord.name] || '';
    container.innerHTML =
      '<div class="dasha-balance-card">' +
        '<div class="db-icon">' + sym + '</div>' +
        '<div class="db-info">' +
          '<span class="db-label">Balance of</span>' +
          '<div class="db-planet">' + sym + ' ' + (lord.name || '—') + '</div>' +
          '<div class="db-duration">⏱ ' + (balance.description || '—') + '</div>' +
        '</div>' +
      '</div>';
  }

  // ===== DASHA TIMELINE =====
  function renderDasha(timelineId, data) {
    var timeline = document.getElementById(timelineId);
    if (!timeline) return;
    timeline.innerHTML = '';
    var periods = data.dashaPeriods || data.dasha || [];
    if (!periods || periods.length === 0) {
      timeline.innerHTML = '<div style="text-align:center;opacity:0.5;padding:20px;">No dasha information available</div>';
      return;
    }
    periods.forEach(function(md) {
      var mdDiv = document.createElement('div');
      mdDiv.className = 'dasha-mahadasha';
      var now = new Date();
      var mdStart = new Date(md.start);
      var mdEnd = new Date(md.end);
      var isCurrent = (now >= mdStart && now <= mdEnd);
      if (isCurrent) mdDiv.classList.add('dasha-md-current');
      var progress = 0;
      if (isCurrent) { var total = mdEnd - mdStart; var elapsed = now - mdStart; progress = total > 0 ? Math.min(100, (elapsed / total) * 100) : 0; }
      var symbol = PLANET_SYMBOLS[md.name] || '';
      var mdHeader = document.createElement('div');
      mdHeader.className = 'dasha-md-header' + (isCurrent ? ' open' : '');
      mdHeader.innerHTML =
        '<div><span class="md-symbol">' + symbol + '</span><span class="md-planet">' + md.name + ' Mahadasha</span>' +
        (isCurrent ? ' <span style="font-size:0.7rem;background:var(--accent);color:#fff;padding:1px 8px;border-radius:8px;margin-left:6px;">Current</span>' : '') +
        (isCurrent ? '<div class="dasha-progress-bar"><div class="dasha-progress-fill" style="width:' + progress.toFixed(0) + '%;"></div></div>' : '') +
        '</div><span class="md-dates">' + formatDateShort(md.start) + ' – ' + formatDateShort(md.end) + '</span>';
      mdDiv.appendChild(mdHeader);

      var adList = md.antardasha || [];
      if (adList.length > 0) {
        var adContainer = document.createElement('div');
        adContainer.className = 'dasha-antardashas';
        adList.forEach(function(ad) {
          var adDiv = document.createElement('div');
          adDiv.className = 'dasha-ad-item';
          var adStart = new Date(ad.start);
          var adEnd = new Date(ad.end);
          var adIsCurrent = (now >= adStart && now <= adEnd);
          if (adIsCurrent) adDiv.classList.add('ad-current');
          var adSym = PLANET_SYMBOLS[ad.name] || '';
          adDiv.innerHTML =
            '<span class="ad-planet">' + adSym + ' ' + ad.name + (adIsCurrent ? ' ◀ Current' : '') +
            '<span class="ad-praty" data-ad-name="' + ad.name + '" data-ad-start="' + ad.start + '" data-ad-end="' + ad.end + '">▼ Praty</span></span>' +
            '<span class="ad-dates">' + formatDateShort(ad.start) + ' – ' + formatDateShort(ad.end) + '</span>';

          // Pratyantardasha sub-list
          var pratyList = ad.pratyantardasha || [];
          if (pratyList.length > 0) {
            var pratyContainer = document.createElement('div');
            pratyContainer.className = 'dasha-praty-list';
            pratyList.forEach(function(pr) {
              var prDiv = document.createElement('div');
              prDiv.className = 'dasha-praty-item';
              var prSym = PLANET_SYMBOLS[pr.name] || '';
              prDiv.innerHTML = '<span>' + prSym + ' ' + pr.name + '</span><span>' + formatDateShort(pr.start) + ' – ' + formatDateShort(pr.end) + '</span>';
              pratyContainer.appendChild(prDiv);
            });
            adDiv.appendChild(pratyContainer);
          }

          adContainer.appendChild(adDiv);
        });
        mdDiv.appendChild(adContainer);
      }

      // Toggle for AD
      mdHeader.addEventListener('click', function() { this.classList.toggle('open'); });

      // Toggle for Pratyantardasha
      mdDiv.querySelectorAll('.ad-praty').forEach(function(el) {
        el.addEventListener('click', function(e) {
          e.stopPropagation();
          var parent = this.closest('.dasha-ad-item');
          var pratyList = parent ? parent.querySelector('.dasha-praty-list') : null;
          if (pratyList) pratyList.classList.toggle('visible');
        });
      });

      timeline.appendChild(mdDiv);
    });
  }

  function formatDateShort(dateStr) {
    if (!dateStr) return '—';
    try { var d = new Date(dateStr); var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']; return d.getDate() + ' ' + months[d.getMonth()] + ' ' + d.getFullYear(); } catch(e) { return dateStr; }
  }

  // ===== ZODIAC & HOUSE DATA =====
  // Supports both English and Vedic/Sanskrit zodiac names
  var ZODIAC_SYMBOLS = {
    'Aries': '♈', 'Taurus': '♉', 'Gemini': '♊', 'Cancer': '♋',
    'Leo': '♌', 'Virgo': '♍', 'Libra': '♎', 'Scorpio': '♏',
    'Sagittarius': '♐', 'Capricorn': '♑', 'Aquarius': '♒', 'Pisces': '♓',
    // Vedic / Sanskrit names
    // The API spells the eighth sign "Vrishchika"; the older spelling without
    // the second h is kept so a cached response still renders.
    'Mesha': '♈', 'Vrishabha': '♉', 'Mithuna': '♊', 'Karka': '♋',
    'Simha': '♌', 'Kanya': '♍', 'Tula': '♎', 'Vrishchika': '♏', 'Vrischika': '♏',
    'Dhanu': '♐', 'Makara': '♑', 'Kumbha': '♒', 'Meena': '♓',
    // Hindi names
    'मेष': '♈', 'वृषभ': '♉', 'मिथुन': '♊', 'कर्क': '♋',
    'सिंह': '♌', 'कन्या': '♍', 'तुला': '♎', 'वृश्चिक': '♏',
    'धनु': '♐', 'मकर': '♑', 'कुंभ': '♒', 'मीन': '♓'
  };
  var ZODIAC_SHORT = {
    'Aries': 'Mes', 'Taurus': 'Vrs', 'Gemini': 'Mth', 'Cancer': 'Krk',
    'Leo': 'Sim', 'Virgo': 'Kan', 'Libra': 'Tul', 'Scorpio': 'Vrs',
    'Sagittarius': 'Dhn', 'Capricorn': 'Mkr', 'Aquarius': 'Kum', 'Pisces': 'Min',
    // Vedic / Sanskrit short names
    'Mesha': 'Mes', 'Vrishabha': 'Vrs', 'Mithuna': 'Mth', 'Karka': 'Krk',
    'Simha': 'Sim', 'Kanya': 'Kan', 'Tula': 'Tul', 'Vrishchika': 'Vrc', 'Vrischika': 'Vrc',
    'Dhanu': 'Dhn', 'Makara': 'Mkr', 'Kumbha': 'Kum', 'Meena': 'Min'
  };

  // North Indian chart layout: 4x4 grid, houses in fixed positions
  var CHART_LAYOUT = [
    [null, 10, 9, null],
    [11, 2, 1, 8],
    [5, 3, 12, 7],
    [null, 4, 6, null]
  ];
  // Map house number to its grid row/col
  var HOUSE_MAP = {};
  for (var ri = 0; ri < 4; ri++) {
    for (var ci = 0; ci < 4; ci++) {
      var h = CHART_LAYOUT[ri][ci];
      if (h !== null) HOUSE_MAP[h] = { row: ri, col: ci };
    }
  }

  var NAKSHATRA_LIST = [
    'Ashwini','Bharani','Krithika','Rohini','Mrigashirsha','Ardra',
    'Punarvasu','Pushya','Ashlesha','Magha','PurvaPhalguni','UttaraPhalguni',
    'Hasta','Chitra','Swati','Vishaka','Anuradha','Jyeshta',
    'Moola','PurvaAshadha','UttaraAshadha','Shravana','Dhanishta','Shatabhisha',
    'PurvaBhadrapada','UttaraBhadrapada','Revati'
  ];

  // ==============================================================
  //  PARSE API — astro-api /kundli/full into what this page renders
  //
  //  The renderers and the whole PDF builder below were written against a
  //  differently-shaped response. Rather than rewrite three thousand lines of
  //  presentation, this one function translates. Everything downstream keeps
  //  reading the same field names it always did, and the shape the engine
  //  actually returns is confined to this file's one seam.
  //
  //  Expected envelope from the proxy:
  //    { success: true, data: { kundli: <astro-api /kundli/full>,
  //                             chart_svg: "<svg…>", chart_svg_north: "<svg…>" } }
  // ==============================================================

  // Longitudes come back as decimal degrees; the table wants degrees and arc
  // minutes, which is how a paper kundli prints them.
  function splitDegrees(decimal) {
    var d = Math.floor(decimal);
    return { degree: d, minute: Math.round((decimal - d) * 60) };
  }

  function parseApiData(json) {
    var raw = json && (json.data || json);
    if (!raw) {
      console.error('[Kundli] parseApiData: response carried no data');
      return null;
    }

    var k = raw.kundli || raw;
    var chartSvg = raw.chart_svg || null;
    var chartSvgNorth = raw.chart_svg_north || null;

    if (!k || (!k.planets && !k.ascendant)) {
      console.error('[Kundli] parseApiData: no chart in the response. Keys seen:', Object.keys(raw || {}));
      return null;
    }

    var asc = k.ascendant || {};
    var ascSign = asc.sign || {};
    var moonSign = k.moonSign || {};
    var sunSign = k.sunSign || {};
    var birthStar = k.nakshatra || {};
    var avakhada = k.avakhada || {};
    var remedies = k.remedies || {};

    // --- planets ------------------------------------------------------
    var planets = (k.planets || []).map(function(p) {
      var sign = p.sign || {};
      var dm = splitDegrees(p.degreeInSign || 0);
      var nak = p.nakshatra || {};
      return {
        name: p.name,
        house: p.house,
        degree: dm.degree,
        minute: dm.minute,
        // The engine's own formatting, kept for anywhere that wants the
        // seconds as well.
        dms: p.dms || '',
        is_retrograde: p.retrograde === true,
        zodiac: { name: sign.name || '' },
        rasi: { name: sign.name || '', lord: { name: sign.lord || '', vedic_name: sign.lord || '' } },
        nakshatra: { name: nak.name || '', pada: nak.pada, lord: { name: nak.lord || '' } }
      };
    });

    // --- houses, each carrying the bodies that fall in it --------------
    var houses = (k.houses || []).map(function(h) {
      var sign = h.sign || {};
      return {
        house: h.house,
        zodiac: { name: sign.name || '' },
        lord: sign.lord || '',
        planets: planets.filter(function(p) { return p.house === h.house; })
      };
    });

    // --- Mangal dosha, pulled out of the dosha list --------------------
    // The engine reports doshas generically; this page has a dedicated card
    // for the one that customers actually ask about.
    var mangalDosha = null;
    (k.doshas || []).forEach(function(d) {
      if (!/mangal|kuja|manglik/i.test(d.name || '')) return;
      var description = d.description || '';
      if (d.evidence && d.evidence.length) {
        description += ' ' + d.evidence.map(function(e) { return e.detail || e.rule; }).join('; ') + '.';
      }
      if (d.cancellation && d.cancellation.length) {
        description += ' Mitigation: ' + d.cancellation.map(function(e) { return e.detail || e.rule; }).join('; ') + '.';
      }
      mangalDosha = {
        has_dosha: d.formed === true,
        severity: d.severity || '',
        description: description.trim(),
        remedies: []
      };
    });
    // A chart with no Mangal dosha reported is a chart without it. Saying so
    // is the answer the customer came for, so the card still renders.
    if (!mangalDosha && k.doshas) {
      mangalDosha = {
        has_dosha: false,
        description: 'Mars does not occupy a house associated with friction in marriage, ' +
          'reckoned from the ascendant, the Moon or Venus. No Mangal dosha is present.',
        remedies: []
      };
    }

    // --- yogas and the remaining doshas, as one accordion --------------
    var yogaDetails = [];
    var yogaList = (k.yogas || []).map(function(y) {
      return { name: y.name, has_yoga: y.formed === true, description: describeFinding(y) };
    });
    if (yogaList.length) yogaDetails.push({ name: 'Yogas', yoga_list: yogaList });

    var otherDoshas = (k.doshas || [])
      .filter(function(d) { return !/mangal|kuja|manglik/i.test(d.name || ''); })
      .map(function(d) {
        return { name: d.name, has_yoga: d.formed === true, description: describeFinding(d) };
      });
    if (otherDoshas.length) yogaDetails.push({ name: 'Doshas', yoga_list: otherDoshas });

    // --- Vimshottari, renamed to the `name` these renderers read -------
    var dashaPeriods = (k.vimshottariDasha || []).map(function(md) {
      return {
        name: md.lord, start: md.start, end: md.end, years: md.years,
        antardasha: (md.antardasha || []).map(function(ad) {
          return {
            name: ad.lord, start: ad.start, end: ad.end, years: ad.years,
            pratyantardasha: (ad.pratyantardasha || []).map(function(pd) {
              return { name: pd.lord, start: pd.start, end: pd.end, years: pd.years };
            })
          };
        })
      };
    });

    // The balance at birth is the unspent remainder of the first mahadasha,
    // which is the first period the engine returns.
    var dashaBalance = null;
    if (dashaPeriods.length > 0) {
      var first = dashaPeriods[0];
      var years = Math.floor(first.years || 0);
      var months = Math.round(((first.years || 0) - years) * 12);
      if (months === 12) { years += 1; months = 0; }
      dashaBalance = {
        lord: { name: first.name },
        description: years + 'y ' + months + 'm remaining at birth, to ' + formatDateShort(first.end)
      };
    }

    // --- the nakshatra cards ------------------------------------------
    // Several of these fields have no counterpart in the engine — it computes
    // a chart, not a lifestyle profile. Absent values are left out rather than
    // invented; renderNakshatraInfo skips anything empty.
    var lifeStone = (remedies.gemstones || []).filter(function(g) { return g.role === 'life'; })[0];
    var nakshatraInfo = {
      deity: birthStar.deity || '',
      ganam: avakhada.gana || '',
      symbol: birthStar.symbol || '',
      animal_sign: avakhada.yoni || '',
      nadi: avakhada.nadi || '',
      syllables: avakhada.nameAlphabet || '',
      birth_stone: lifeStone ? (lifeStone.stone + (lifeStone.classicalStone ? ' (classically ' + lifeStone.classicalStone + ')' : '')) : '',
      planet: birthStar.lord || '',
      varna: avakhada.varna || '',
      vashya: avakhada.vashya || '',
      tatva: avakhada.tatva || '',
      paya: avakhada.paya || ''
    };

    var rawNakshatra = {
      nakshatra: {
        name: birthStar.name || '',
        pada: birthStar.pada || '',
        lord: { name: birthStar.lord || '' }
      },
      chandra_rasi: { name: moonSign.name || '' },
      soorya_rasi: { name: sunSign.name || '' },
      zodiac: { name: ascSign.name || '' },
      additional_info: nakshatraInfo
    };

    // buildRasiLordMap still reads the older planet-position shape, so it is
    // handed one built from the same planets rather than being special-cased.
    var planetPositions = {
      planet_position: planets.map(function(p) {
        return {
          name: p.name, degree: p.degree, position: p.house,
          is_retrograde: p.is_retrograde, rasi: p.rasi, nakshatra: p.nakshatra
        };
      })
    };

    var parsed = {
      nakshatra: birthStar.name ? (birthStar.name + ' (' + (birthStar.lord || '') + ')') : '—',
      rashi: moonSign.name || '—',
      lagna: ascSign.name || '—',
      pada: birthStar.pada || '—',
      nakshatraInfo: nakshatraInfo,
      rawNakshatra: rawNakshatra,
      mangalDosha: mangalDosha,
      yogaDetails: yogaDetails,
      dashaPeriods: dashaPeriods,
      dashaBalance: dashaBalance,
      planets: planets,
      houses: houses,
      chartSvg: chartSvg,
      chartSvgNorth: chartSvgNorth,
      planetPositions: planetPositions,
      // Kept whole so anything added later can reach the parts this
      // translation does not carry across — ashtakavarga, shadbala, KP.
      apiKundli: k
    };

    console.log('[Kundli] Parsed astro-api chart —', {
      lagna: parsed.lagna, rashi: parsed.rashi, nakshatra: parsed.nakshatra,
      planets: planets.length, houses: houses.length,
      yogas: yogaList.length, doshas: (k.doshas || []).length,
      mahadashas: dashaPeriods.length,
      hasSouthSvg: !!chartSvg, hasNorthSvg: !!chartSvgNorth
    });

    return parsed;
  }

  // describeFinding turns a rule result into a sentence. The engine explains
  // why a rule fired as structured evidence, and that reasoning is the part
  // worth reading — it is what separates this from a horoscope column.
  function describeFinding(f) {
    var text = f.description || '';
    if (!f.formed && f.reason) return (text ? text + ' ' : '') + 'Not formed: ' + f.reason;
    if (f.evidence && f.evidence.length) {
      var detail = f.evidence.map(function(e) { return e.detail || e.rule; }).join('; ');
      if (detail) text = (text ? text + ' ' : '') + '(' + detail + ')';
    }
    return text;
  }

  // ===== RENDER YANTRA (North Indian Style 4x4 Grid) =====
  function renderYantra(parsedData) {
    var wrapper = document.getElementById('yantraWrapperNorth-' + sId);
    var legend = document.getElementById('yantraLegendNorth-' + sId);
    var card = document.getElementById('chartYantraCard-' + sId);
    if (!wrapper || !card) return;

    var houses = parsedData.houses || [];
    var planets = parsedData.planets || [];
    var lagnaZodiac = parsedData.lagna || '';

    // Build map of house -> zodiac
    var houseZodiacMap = {};
    houses.forEach(function(h) {
      if (h.zodiac) houseZodiacMap[h.house] = h.zodiac.name || h.zodiac;
      if (h.zodiac && h.zodiac.name) houseZodiacMap[h.house] = h.zodiac.name;
    });

    // Build map of house -> planets
    var housePlanetsMap = {};
    for (var i = 1; i <= 12; i++) housePlanetsMap[i] = [];
    planets.forEach(function(p) {
      var hNum = p.house || 1;
      if (!housePlanetsMap[hNum]) housePlanetsMap[hNum] = [];
      housePlanetsMap[hNum].push(p);
    });

    // Also check for planets in houses from houses array
    houses.forEach(function(h) {
      var hNum = h.house;
      if (h.planets && h.planets.length > 0) {
        h.planets.forEach(function(p) {
          var pObj = p.planet || p;
          var pName = pObj.name || pObj.vedic_name || '';
          if (pName && !housePlanetsMap[hNum].some(function(ex) { return (ex.name || '') === pName; })) {
            housePlanetsMap[hNum].push(pObj);
          }
        });
      }
    });

    // Detect lagna house (the house whose zodiac matches lagna)
    var lagnaHouse = 1;
    for (var i = 1; i <= 12; i++) {
      if (houseZodiacMap[i] && houseZodiacMap[i].toLowerCase() === lagnaZodiac.toLowerCase()) {
        lagnaHouse = i;
        break;
      }
    }

    // Recalculate north Indian chart layout based on lagna
    // In North Indian chart: house 1 is always at fixed position (1,2)
    // The actual house number at each position depends on lagna
    var lagnaOffset = lagnaHouse - 1;
    var layoutFixed = [
      [null, 10, 9, null],
      [11, 2, 1, 8],
      [5, 3, 12, 7],
      [null, 4, 6, null]
    ];

    card.style.display = 'block';
    var gridHtml = '<div class="kundli-yantra">';
    for (var r = 0; r < 4; r++) {
      for (var c = 0; c < 4; c++) {
        var baseH = layoutFixed[r][c];
        if (baseH === null) {
          gridHtml += '<div class="kundli-empty-house">✦</div>';
          continue;
        }
        // Actual house number = ((baseH - 1 + lagnaOffset) % 12) + 1
        var actualH = ((baseH - 1 + lagnaOffset) % 12) + 1;
        var zodiacName = houseZodiacMap[actualH] || '—';
        var zSym = ZODIAC_SYMBOLS[zodiacName] || zodiacName.substring(0, 3) || '?';
        var zShort = ZODIAC_SHORT[zodiacName] || zodiacName.substring(0, 3) || '?';

        var planetHtml = '';
        var hPlanets = housePlanetsMap[actualH] || [];
        hPlanets.forEach(function(p) {
          var pName = p.name || p.vedic_name || '';
          var pSym = PLANET_SYMBOLS[pName] || pName.substring(0, 2) || '?';
          var isRetro = p.is_retrograde === true || p.isRetrograde === true;
          planetHtml += '<span class="house-planet' + (isRetro ? ' retro' : '') + '" title="' + pName + (isRetro ? ' (Retrograde)' : '') + (p.degree ? ' ' + p.degree.toFixed(1) + '°' : '') + '">' + pSym + '</span>';
        });

        var isLagnaHouse = (actualH === lagnaHouse);
        gridHtml +=
          '<div class="kundli-house' + (isLagnaHouse ? ' highlight-lagna' : '') + '">' +
            '<span class="house-num">' + actualH + '</span>' +
            '<span class="house-zodiac">' + zSym + '</span>' +
            (planetHtml ? '<div class="house-planets">' + planetHtml + '</div>' : '<div class="house-planets" style="opacity:0.3;">—</div>') +
            (isLagnaHouse ? '<span class="house-lagna-marker">ASC</span>' : '') +
          '</div>';
      }
    }
    gridHtml += '</div>';
    wrapper.innerHTML = gridHtml;

    // Legend
    legend.innerHTML =
      '<span>🪐 Planet positions in each house</span>' +
      '<span><span class="legend-retro">R</span> = Retrograde</span>' +
      '<span style="color:var(--accent);font-weight:600;">ASC</span> = Lagna (Ascendant)' +
      '<span>🔆 Lagna: ' + lagnaZodiac + '</span>';
  }

  // ===== RENDER SVG CHART (South Indian from chart API) =====
  function renderSvgChart(parsedData) {
    var wrapper = document.getElementById('yantraWrapper-' + sId);
    var legend = document.getElementById('yantraLegend-' + sId);
    var card = document.getElementById('chartYantraCard-' + sId);
    if (!wrapper || !card) return;

    var svgXml = parsedData.chartSvg;
    if (!svgXml) {
      console.warn('[Kundli] No South Indian SVG chart data available from API.');
      wrapper.innerHTML = '<div style="text-align:center;opacity:0.5;padding:20px;">South Indian chart not available</div>';
      return;
    }

    card.style.display = 'block';

    try {
      wrapper.innerHTML =
        '<div style="display:flex;justify-content:center;overflow-x:auto;padding:10px;">' +
          svgXml +
        '</div>';

      var svgEl = wrapper.querySelector('svg');
      if (svgEl) {
        svgEl.style.maxWidth = '100%';
        svgEl.style.height = 'auto';
      } else {
        console.warn('[Kundli] SVG chart data did not contain a valid <svg> element.');
        wrapper.innerHTML = '<div style="text-align:center;opacity:0.5;padding:20px;">South Indian chart not available</div>';
        return;
      }

      legend.innerHTML =
        '<span>🪐 South Indian style chart</span>' +
        '<span>Numbers (1-12) = House positions</span>' +
        '<span><span class="legend-retro">R</span> = Retrograde</span>' +
        '<span>🪐 Planet symbols shown in each house</span>';
    } catch (e) {
      console.warn('[Kundli] Failed to render South Indian SVG chart:', e.message);
      wrapper.innerHTML = '<div style="text-align:center;opacity:0.5;padding:20px;">South Indian chart not available</div>';
    }
  }

  // ===== RENDER NORTH INDIAN SVG CHART (from chart API) =====
  function renderSvgChartNorth(parsedData) {
    var wrapper = document.getElementById('yantraWrapperNorth-' + sId);
    var legend = document.getElementById('yantraLegendNorth-' + sId);
    var card = document.getElementById('chartYantraCard-' + sId);
    if (!wrapper || !card) return;

    var svgXml = parsedData.chartSvgNorth;
    if (!svgXml) {
      console.warn('[Kundli] No North Indian SVG chart data from API. Falling back to grid chart.');
      renderYantra(parsedData);
      return;
    }

    card.style.display = 'block';

    try {
      wrapper.innerHTML =
        '<div style="display:flex;justify-content:center;overflow-x:auto;padding:10px;">' +
          svgXml +
        '</div>';

      var svgEl = wrapper.querySelector('svg');
      if (svgEl) {
        svgEl.style.maxWidth = '100%';
        svgEl.style.height = 'auto';
      } else {
        console.warn('[Kundli] North Indian SVG chart data did not contain a valid <svg> element. Falling back to grid chart.');
        renderYantra(parsedData);
        return;
      }

      legend.innerHTML =
        '<span>🔯 North Indian style chart</span>' +
        '<span>Numbers (1-12) = House positions</span>' +
        '<span><span class="legend-retro">R</span> = Retrograde</span>' +
        '<span>🪐 Planet symbols shown in each house</span>';
    } catch (e) {
      console.warn('[Kundli] Failed to render North Indian SVG chart:', e.message, '. Falling back to grid chart.');
      renderYantra(parsedData);
    }
  }

  // ===== BUILD PLANET RASI LORD MAP =====
  function buildRasiLordMap(parsedData) {
    var map = {};
    var pp = parsedData.planetPositions;
    if (!pp) {
      console.warn('[Kundli] buildRasiLordMap: No planetPositions data available. Rasi Lord column will show "—".');
      return map;
    }

    // Handle different possible structures:
    // 1. pp.planet_position (array) — from Prokerala API
    // 2. pp.data.planet_position (nested) — if wrapped in data
    // 3. pp itself is an array of planet positions
    var planetArray = null;
    if (Array.isArray(pp.planet_position)) {
      planetArray = pp.planet_position;
    } else if (pp.data && Array.isArray(pp.data.planet_position)) {
      planetArray = pp.data.planet_position;
    } else if (Array.isArray(pp)) {
      planetArray = pp;
    }

    if (!planetArray || planetArray.length === 0) {
      console.warn('[Kundli] buildRasiLordMap: No planet_position array found in planetPositions data.');
      return map;
    }

    planetArray.forEach(function(p) {
      if (p && p.rasi && p.rasi.lord) {
        map[p.name] = {
          rasiName: p.rasi.name,
          lordName: p.rasi.lord.name,
          lordVedicName: p.rasi.lord.vedic_name,
          degree: p.degree,
          position: p.position,
          isRetrograde: p.is_retrograde
        };
      }
    });

    if (Object.keys(map).length === 0) {
      console.warn('[Kundli] buildRasiLordMap: No planets with rasi lord data found in planet positions.');
    }

    return map;
  }

  // ===== RENDER PLANET TABLE =====
  function renderPlanetTable(parsedData) {
    var tbody = document.getElementById('planetTableBody-' + sId);
    var card = document.getElementById('planetTableCard-' + sId);
    var detailCard = document.getElementById('houseDetailCard-' + sId);
    var houseEl = document.getElementById('houseDetails-' + sId);
    if (!tbody || !card) return;

    var planets = parsedData.planets || [];
    var rasiLordMap = buildRasiLordMap(parsedData);
    if (!planets || planets.length === 0) { card.style.display = 'none'; return; }
    card.style.display = 'block';

    // Update table header to include Rasi Lord column
    var thead = card.querySelector('thead tr');
    if (thead && !thead.querySelector('.th-rasi-lord')) {
      var rasiLordTh = document.createElement('th');
      rasiLordTh.className = 'th-rasi-lord';
      rasiLordTh.textContent = 'Rasi Lord';
      thead.appendChild(rasiLordTh);
    }

    tbody.innerHTML = '';
    planets.forEach(function(p) {
      var pName = p.name || p.vedic_name || '';
      var pSym = PLANET_SYMBOLS[pName] || '';
      var house = p.house || '—';
      var degree = p.degree !== undefined ? p.degree : (p.position ? p.position.degree : null);
      var min = p.minute !== undefined ? p.minute : (p.position ? p.position.minute : 0);
      var zodName = (p.zodiac && p.zodiac.name) || (p.rasi && p.rasi.name) || '—';
      var zSym = ZODIAC_SYMBOLS[zodName] || '';
      var nakshatra = (p.nakshatra && p.nakshatra.name) || (p.nakshatra_detail && p.nakshatra_detail.name) || '—';
      var isRetro = p.is_retrograde === true || p.isRetrograde === true;
      var degreeStr = degree !== null ? degree + '°' + (min ? min + "'" : '') : '—';

      // Get rasi lord info from planet positions data
      var rl = rasiLordMap[pName] || null;
      var rasiLordStr = '—';
      if (rl) {
        rasiLordStr = rl.lordVedicName || rl.lordName || '—';
        // Add planet symbol for the lord
        var lordSym = PLANET_SYMBOLS[rl.lordName] || '';
        rasiLordStr = lordSym + ' ' + rasiLordStr;
      }

      var tr = document.createElement('tr');
      tr.innerHTML =
        '<td><span class="planet-symbol">' + pSym + '</span> ' + pName + '</td>' +
        '<td>' + house + '</td>' +
        '<td>' + zSym + ' ' + zodName + '</td>' +
        '<td class="planet-degree">' + degreeStr + '</td>' +
        '<td>' + nakshatra + '</td>' +
        '<td>' + (isRetro ? '<span class="retro-badge">Retro</span>' : '<span style="color:#27ae60;">Direct</span>') + '</td>' +
        '<td>' + rasiLordStr + '</td>';
      tbody.appendChild(tr);
    });

    // Update the Planets heading to mention Rasi Lords
    var cardTitle = card.querySelector('.card-title');
    if (cardTitle && !cardTitle.textContent.includes('Rasi')) {
      cardTitle.textContent = cardTitle.textContent.replace('Planet Positions', 'Planet Positions & Rasi Lords');
    }

    // House details
    if (detailCard && houseEl) {
      var houses = parsedData.houses || [];
      if (houses.length > 0) {
        detailCard.style.display = 'block';
        houseEl.innerHTML = '';
        houses.forEach(function(h) {
          var hNum = h.house;
          var zodName = (h.zodiac && h.zodiac.name) || '—';
          var zSym = ZODIAC_SYMBOLS[zodName] || '';
          var hPlanets = h.planets || [];
          var planetNames = hPlanets.map(function(p) {
            var pObj = p.planet || p;
            var pn = pObj.name || pObj.vedic_name || '';
            var ps = PLANET_SYMBOLS[pn] || '';
            var isR = pObj.is_retrograde === true || p.is_retrograde === true;
            return ps + ' ' + pn + (isR ? ' (R)' : '');
          }).join(', ') || '—';

          var hDiv = document.createElement('div');
          hDiv.className = 'kundli-planet-detail';
          hDiv.innerHTML =
            '<span class="pd-symbol">' + zSym + '</span>' +
            '<div class="pd-info">' +
              '<span class="pd-name">House ' + hNum + ': ' + zodName + '</span>' +
              '<div class="pd-detail">' + (planetNames !== '—' ? 'Planets: ' + planetNames : 'No planets') + '</div>' +
            '</div>';
          houseEl.appendChild(hDiv);
        });
      } else {
        detailCard.style.display = 'none';
      }
    }
  }

  // ===== SHOW RESULTS =====
  function showInlineResults(formData, parsedData) {
    document.getElementById('resultName-' + sId).textContent = formData.name + (formData.gender === 'male' ? ' ♂' : ' ♀');
    document.getElementById('resultDatetime-' + sId).textContent = '📅 ' + formatDate(formData.dob) + ' | ⏰ ' + formatTime(formData.tob) + ' | 📍 ' + formData.place;
    setStep(3);
    renderBadges('badgeRow-' + sId, parsedData);
    // Always render both chart styles
    renderSvgChart(parsedData);
    renderSvgChartNorth(parsedData);
    renderPlanetTable(parsedData);
    renderNakshatraSummary('nakshatraSummary-' + sId, parsedData);
    renderNakshatraInfo('nakshatraGrid-' + sId, parsedData);
    renderMangalDosha('mangalContent-' + sId, parsedData);
    renderYogaDetails('yogaAccordion-' + sId, parsedData);
    renderDashaBalance('dashaBalanceContent-' + sId, parsedData);
    renderDasha('dashaTimeline-' + sId, parsedData);

    // Report preview
    renderReportPreview('reportPreviewContent-' + sId, formData, parsedData);

    results.classList.add('visible');
    placeholder.style.display = 'none';
    apiError.classList.remove('visible');
    actions.classList.add('visible');

    var cards = results.querySelectorAll('.kundli-glass-card');
    cards.forEach(function(card, i) { card.style.animationDelay = (i * 0.08) + 's'; card.classList.add('visible'); });
    setTimeout(function() { results.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 200);
  }

  // ===== REPORT PREVIEW (tab) =====
  function renderReportPreview(containerId, formData, parsedData) {
    var container = document.getElementById(containerId);
    if (!container) return;
    var card = document.getElementById('reportPreviewCard-' + sId);
    if (!card) return;
    card.style.display = 'block';

    var html = '';

    // Nakshatra
    html += '<div class="report-section" style="padding:0 0 20px;border-bottom:1px solid var(--border-c);margin-bottom:20px;">' +
      '<h3 style="font-size:1.1rem;color:var(--heading-c);margin:0 0 12px;">🔯 Nakshatra Details</h3>';
    if (parsedData.rawNakshatra) {
      var nd = parsedData.rawNakshatra;
      html += '<div style="display:flex;flex-wrap:wrap;gap:10px;">';
      if (nd.nakshatra) html += '<span class="report-badge">⭐ Nakshatra: <strong>' + (nd.nakshatra.name || '—') + '</strong> (Pada ' + (nd.nakshatra.pada || '—') + ')</span>';
      if (nd.chandra_rasi) html += '<span class="report-badge">🌙 Chandra Rashi: <strong>' + nd.chandra_rasi.name + '</strong></span>';
      if (nd.soorya_rasi) html += '<span class="report-badge">🔆 Soorya Rashi: <strong>' + nd.soorya_rasi.name + '</strong></span>';
      if (nd.zodiac) html += '<span class="report-badge">♈ Zodiac: <strong>' + nd.zodiac.name + '</strong></span>';
      html += '</div>';
    }
    html += '</div>';

    // Mangal
    if (parsedData.mangalDosha) {
      html += '<div class="report-section" style="padding:0 0 20px;border-bottom:1px solid var(--border-c);margin-bottom:20px;">' +
        '<h3 style="font-size:1.1rem;color:var(--heading-c);margin:0 0 12px;">🔥 Mangal Dosha</h3>' +
        '<div style="font-size:0.95rem;">' +
          '<span style="font-weight:600;color:' + (parsedData.mangalDosha.has_dosha ? "var(--danger-c)" : "var(--success-c)") + ';">' +
            (parsedData.mangalDosha.has_dosha ? '⚠️ Manglik' : '✅ Not Manglik') + '</span>' +
          '<p style="margin:4px 0 0;opacity:0.7;">' + (parsedData.mangalDosha.description || '') + '</p>' +
        '</div></div>';
    }

    // Dasha
    if (parsedData.dashaPeriods && parsedData.dashaPeriods.length > 0) {
      html += '<div class="report-section" style="padding:0 0 20px;border-bottom:1px solid var(--border-c);margin-bottom:20px;">' +
        '<h3 style="font-size:1.1rem;color:var(--heading-c);margin:0 0 12px;">⏳ Current & Upcoming Dashas</h3>';
      parsedData.dashaPeriods.slice(0, 3).forEach(function(md) {
        var now = new Date();
        var mdStart = new Date(md.start);
        var mdEnd = new Date(md.end);
        var isCurrent = (now >= mdStart && now <= mdEnd);
        var sym = PLANET_SYMBOLS[md.name] || '';
        html += '<div style="display:flex;justify-content:space-between;padding:4px 0;border-bottom:1px dashed var(--border-c);font-size:0.85rem;' + (isCurrent ? 'background:var(--accent)08;padding:4px 8px;border-radius:4px;' : '') + '">' +
          '<span style="font-weight:600;color:var(--accent);">' + sym + ' ' + md.name + (isCurrent ? ' <span style="font-size:0.65rem;background:var(--accent);color:#fff;padding:1px 6px;border-radius:8px;">Current</span>' : '') + '</span>' +
          '<span style="color:#888;">' + formatDateShort(md.start) + ' – ' + formatDateShort(md.end) + '</span></div>';
      });
      html += '</div>';
    }

    container.innerHTML = html;
  }

  // ===== RAZORPAY ORDER CREATION =====
  function createRazorpayOrder() {
    return fetch(API_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'create-order' })
    }).then(function(res) {
      return res.json().then(function(data) {
        if (!res.ok) throw new Error(data.error || 'Failed to create Razorpay order');
        return data;
      });
    });
  }

  // ===== RAZORPAY PAYMENT FLOW =====
  function openRazorpayCheckout(orderData, formData) {
    return new Promise(function(resolve, reject) {
      RAZORPAY_KEY_ID = orderData.key_id;
      var options = {
        key: orderData.key_id,
        amount: orderData.amount,
        currency: orderData.currency,
        name: 'Divya Ratna',
        description: 'Birth Chart (Kundli) Analysis - ₹490',
        image: 'https://www.climatrix.serventys.in/gemstone/rings/d62ddd4b-e789-4722-b0fa-bb43a711c531.png',
        order_id: orderData.order_id,
        handler: function(response) {
          storedPayment = {
            razorpay_payment_id: response.razorpay_payment_id,
            razorpay_order_id: response.razorpay_order_id,
            razorpay_signature: response.razorpay_signature
          };
          // Persist payment proof to sessionStorage for recovery if page is reloaded
          try {
            localStorage.setItem('km_pendingPayment', JSON.stringify(storedPayment));
            localStorage.setItem('km_pendingFormData', JSON.stringify(formData));
          } catch(e) {}
          resolve(storedPayment);
        },
        prefill: {
          name: formData.name || '',
          contact: '',
          email: ''
        },
        theme: {
          color: "var(--danger-c)"
        },
        modal: {
          ondismiss: function() {
            reject(new Error('Payment cancelled. You must complete payment to generate Kundli.'));
          }
        }
      };
      var rzp = new Razorpay(options);
      rzp.on('payment.failed', function(response) {
        reject(new Error(response.error.description || 'Payment failed. Please try again.'));
      });
      rzp.open();
    });
  }

  // describeApiError turns a failure into something a customer can act on.
  // The astrology API reports invalid input as a list of named fields — a
  // birthplace with no coordinates, a timezone it will not accept — and that
  // is far more useful than "HTTP 400".
  function describeApiError(json, status) {
    if (!json) return 'The server returned HTTP ' + status + '.';
    if (Array.isArray(json.fields) && json.fields.length) {
      return json.fields.map(function(f) { return f.field + ': ' + f.message; }).join(' — ');
    }
    return json.error || json.message || 'The server returned HTTP ' + status + '.';
  }

  // ===== CALL API (with payment verification) =====
  function callApi(formData) {
    var payload = {
      type: 'making',
      birth: buildBirthRecord(formData)
    };
    // Include payment details if available
    if (storedPayment) {
      payload.razorpay_payment_id = storedPayment.razorpay_payment_id;
      payload.razorpay_order_id = storedPayment.razorpay_order_id;
      payload.razorpay_signature = storedPayment.razorpay_signature;
    }
    return fetch(API_ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload)
    }).then(function(res) {
      // Try to get response text first, then parse as JSON
      return res.text().then(function(text) {
        if (!text || text.trim() === '') {
          if (!res.ok) {
            throw new Error('Server returned HTTP ' + res.status + ' with empty response. Check worker logs.');
          }
          throw new Error('Received empty response from server. Check worker configuration.');
        }
        try {
          var data = JSON.parse(text);
          if (!res.ok) {
            // If payment is required (402), throw a specific error
            if (res.status === 402) {
              throw new Error(data.error || 'Payment required. Please complete payment of ₹490.');
            }
            throw new Error(describeApiError(data, res.status));
          }
          return data;
        } catch (e) {
          if (e instanceof SyntaxError) {
            throw new Error('Invalid response from server (not JSON). Status: ' + res.status + '. Response: ' + text.substring(0, 100));
          }
          throw e;
        }
      });
    });
  }

  // ===== GENERATE FULL REPORT =====
  function generateReport(formData, parsedData) {
    document.getElementById('reportDate-' + sId).textContent = new Date().toLocaleDateString('en-IN', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    document.getElementById('reportName-' + sId).textContent = formData.name;
    document.getElementById('reportDetails-' + sId).innerHTML = '📅 ' + formatDate(formData.dob) + '<br>⏰ ' + formatTime(formData.tob) + '<br>📍 ' + formData.place + '<br>⚤ ' + (formData.gender === 'male' ? 'Male' : 'Female');

    // Badges
    var reportBadges = document.getElementById('reportBadges-' + sId);
    if (reportBadges) {
      reportBadges.innerHTML = '';
      var row = document.createElement('div');
      row.className = 'report-badge-row';
      [ { icon: '🔆', label: 'Lagna', value: parsedData.lagna },
        { icon: '🌙', label: 'Rashi', value: parsedData.rashi },
        { icon: '⭐', label: 'Nakshatra', value: parsedData.nakshatra },
        { icon: '🔯', label: 'Pada', value: parsedData.pada } ]
      .forEach(function(b) {
        row.innerHTML += '<span class="report-badge">' + b.icon + ' ' + b.label + ': <strong>' + b.value + '</strong></span>';
      });
      reportBadges.appendChild(row);
    }

    // Nakshatra in report
    var reportNakshatra = document.getElementById('reportNakshatra-' + sId);
    if (reportNakshatra && parsedData.rawNakshatra) {
      var nd = parsedData.rawNakshatra;
      var html = '<div class="report-badge-row">';
      if (nd.nakshatra) html += '<span class="report-badge">⭐ Nakshatra: <strong>' + (nd.nakshatra.name || '—') + '</strong> (Pada ' + (nd.nakshatra.pada || '—') + ')</span>';
      if (nd.chandra_rasi) html += '<span class="report-badge">🌙 Chandra Rashi: <strong>' + nd.chandra_rasi.name + '</strong></span>';
      if (nd.soorya_rasi) html += '<span class="report-badge">🔆 Soorya Rashi: <strong>' + nd.soorya_rasi.name + '</strong></span>';
      if (nd.zodiac) html += '<span class="report-badge">♈ Zodiac: <strong>' + nd.zodiac.name + '</strong></span>';
      if (nd.nakshatra && nd.nakshatra.lord) html += '<span class="report-badge">🪐 Lord: <strong>' + nd.nakshatra.lord.name + '</strong></span>';
      html += '</div>';
      if (nd.additional_info) {
        var ai = nd.additional_info;
        html += '<div style="display:flex;flex-wrap:wrap;gap:8px;margin-top:12px;">';
        if (ai.deity) html += '<span class="report-badge">🕉️ Deity: ' + ai.deity + '</span>';
        if (ai.ganam) html += '<span class="report-badge">👥 Ganam: ' + ai.ganam + '</span>';
        if (ai.birth_stone) html += '<span class="report-badge">💎 Stone: ' + ai.birth_stone + '</span>';
        if (ai.syllables) html += '<span class="report-badge">🔤 Syllables: ' + ai.syllables + '</span>';
        if (ai.symbol) html += '<span class="report-badge">🔣 Symbol: ' + ai.symbol + '</span>';
        html += '</div>';
      }
      reportNakshatra.innerHTML = html;
    }

    // Mangal in report
    var reportMangal = document.getElementById('reportMangal-' + sId);
    if (reportMangal && parsedData.mangalDosha) {
      var md = parsedData.mangalDosha;
      reportMangal.innerHTML = '<div style="text-align:center;font-size:1rem;">' +
        '<span style="font-weight:700;color:' + (md.has_dosha ? "var(--danger-c)" : "var(--success-c)") + ';">' + (md.has_dosha ? '⚠️ Manglik' : '✅ Not Manglik') + '</span>' +
        '<p style="opacity:0.7;margin:4px 0;">' + (md.description || '') + '</p></div>';
    }

    // Dasha in report
    var reportDasha = document.getElementById('reportDasha-' + sId);
    if (reportDasha) {
      reportDasha.innerHTML = '';
      var periods = parsedData.dashaPeriods || parsedData.dasha || [];
      if (periods.length > 0) {
        periods.slice(0, 3).forEach(function(md) {
          var div = document.createElement('div');
          div.className = 'report-dasha-item';
          var now = new Date();
          var isCurrent = (now >= new Date(md.start) && now <= new Date(md.end));
          if (isCurrent) div.classList.add('current');
          var badgeHtml = isCurrent ? '<span class="current-badge">Current</span>' : '';
          var sym = PLANET_SYMBOLS[md.name] || '';
          div.innerHTML = '<span class="dasha-name">' + sym + ' ' + md.name + '</span><span class="dasha-dates">' + formatDateShort(md.start) + ' – ' + formatDateShort(md.end) + ' ' + badgeHtml + '</span>';
          reportDasha.appendChild(div);
        });
      } else {
        reportDasha.innerHTML = '<div style="text-align:center;opacity:0.5;padding:10px;">No dasha info</div>';
      }
    }
  }

  // ===== HISTORY =====
  function saveToHistory(formData, parsedData) {
    try {
      var key = prefix + 'history';
      var history = JSON.parse(localStorage.getItem(key) || '[]');
      history.unshift({ name: formData.name, gender: formData.gender, date: new Date().toISOString(), lagna: parsedData.lagna, rashi: parsedData.rashi, nakshatra: parsedData.nakshatra });
      if (history.length > 5) history = history.slice(0, 5);
      localStorage.setItem(key, JSON.stringify(history)); renderHistory();
    } catch(e) {}
  }
  function renderHistory() {
    try {
      var key = prefix + 'history';
      var history = JSON.parse(localStorage.getItem(key) || '[]');
      if (history.length === 0) { historyEl.classList.remove('visible'); return; }
      historyEl.classList.add('visible');
      historyList.innerHTML = '';
      history.forEach(function(item) {
        var btn = document.createElement('button');
        btn.type = 'button'; btn.className = 'kundli-history-item';
        btn.innerHTML = '👤 ' + item.name + ' — ' + item.lagna;
        btn.title = 'Rashi: ' + item.rashi + ' | Nakshatra: ' + item.nakshatra;
        btn.addEventListener('click', function() {
          document.getElementById('personName-' + sId).value = item.name;
          if (item.gender === 'male') document.getElementById('genderMale-' + sId).click(); else document.getElementById('genderFemale-' + sId).click();
        });
        historyList.appendChild(btn);
      });
    } catch(e) {}
  }

  // ===== GEOCODE PLACE =====
  function geocodePlace(placeName) {
    var coordsEl = document.getElementById('placeCoords-' + sId);
    return fetch('https://nominatim.openstreetmap.org/search?format=json&q=' + encodeURIComponent(placeName) + '&limit=1&addressdetails=1', {
      headers: { 'Accept-Language': 'en' }
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data && data.length > 0) {
        var place = data[0];
        var input = document.getElementById('personPlace-' + sId);
        var cc = countryCodeOf(place) || '';
        input.dataset.lat = place.lat;
        input.dataset.lon = place.lon;
        input.dataset.cc = cc;
        // A place typed by hand and never picked from the list still has to
        // set the zone, or it keeps whatever the previous place left behind.
        applyZone(resolveZone(cc, place.lat, place.lon));
        if (coordsEl) {
          coordsEl.textContent = '📍 ' + parseFloat(place.lat).toFixed(4) + ', ' + parseFloat(place.lon).toFixed(4);
          coordsEl.style.display = 'inline';
        }
        return { latitude: place.lat, longitude: place.lon, countryCode: cc };
      }
      throw new Error('Could not find coordinates for "' + placeName + '". Please select a place from the suggestions.');
    });
  }

  // ===== RAZORPAY PAYMENT + API CALL (with Dev Mode support) =====
  function payAndGenerateKundli(formData) {
    setStep(2);
    submitBtn.classList.add('loading');
    submitBtn.disabled = true;
    errorText.textContent = '';

    // DEV MODE: skip payment and the proxy, but walk the same two stages the
    // real flow does — chart first, then the reading arriving later — so the
    // Documents panel, the progress bar and the hand-off between them can be
    // checked without spending a payment to find a layout bug.
    if (IS_DEV_MODE) {
      console.log('[Dev Mode] Simulating the two-stage flow with dummy data');
      setTimeout(function() {
        handleParsedData(getDummyParsedData(), formData);
        var devOrder = {
          success: true,
          token: 'DEV0000000',
          kundli: 'ready',
          reading: 'generating',
          readingStartedAt: new Date().toISOString(),
          documents: { kundli: DEV_DOC_HREF }
        };
        renderDocuments(devOrder);
        // Stage two lands on the compressed developer timetable.
        setTimeout(function() {
          devOrder.reading = 'ready';
          devOrder.documents.reading = DEV_DOC_HREF;
          renderDocuments(devOrder);
          showPdfToast('\uD83D\uDCD6 Your full reading is ready to download. (Developer mode)');
        }, EXPECTED_READING_MS);
      }, 800);
      return;
    }

    // Step 1: Create Razorpay order
    createRazorpayOrder()
      .then(function(orderData) {
        // Step 2: Open Razorpay checkout for payment
        return openRazorpayCheckout(orderData, formData);
      })
      .then(function(paymentData) {
        // Step 3: Payment successful — now call the API with payment proof
        return callApi(formData);
      })
      .then(function(json) {
        handleApiSuccess(json, formData);
      })
      .catch(function(err) {
        handleApiError(err);
      });
  }

  // ===== MAIN SUBMIT =====
  form.addEventListener('submit', function(e) {
    e.preventDefault();
    apiError.classList.remove('visible');
    results.classList.remove('visible');
    actions.classList.remove('visible');
    if (!validateForm()) return;

    var formData = getFormData();

    // Check if lat/lon are missing — try to geocode first
    if (!formData.latitude || !formData.longitude) {
      setStep(2);
      submitBtn.classList.add('loading');
      submitBtn.disabled = true;

      geocodePlace(formData.place)
        .then(function(coords) {
          formData.latitude = coords.latitude;
          formData.longitude = coords.longitude;
          // Update the dataset so subsequent submissions work
          var input = document.getElementById('personPlace-' + sId);
          input.dataset.lat = coords.latitude;
          input.dataset.lon = coords.longitude;
          input.dataset.cc = coords.countryCode || '';
          // Re-read the zone: geocodePlace resolves it from the place it just
          // found, and formData was built before that happened. Without this
          // the chart is computed under whatever zone the field held before,
          // which is the exact silent-wrong-ascendant this page had.
          formData.timezone = document.getElementById('personTz-' + sId).value;
          // Now proceed with payment + API call
          return payAndGenerateKundli(formData);
        })
        .catch(function(err) {
          submitBtn.classList.remove('loading');
          submitBtn.disabled = false;
          errorText.textContent = err.message || 'Could not determine location. Please select a place from the suggestions.';
          apiError.classList.add('visible');
          setStep(1);
        });
      return;
    }

    // Proceed with payment + API call
    payAndGenerateKundli(formData);
  });

  function handleApiSuccess(json, formData) {
    var parsed = parseApiData(json);
    if (!parsed) {
      submitBtn.classList.remove('loading'); submitBtn.disabled = false;
      errorText.textContent = 'The chart came back in a shape this page does not recognise. ' +
        'Check that the proxy is returning the astrology API response under data.kundli.';
      apiError.classList.add('visible'); return;
    }
    handleParsedData(parsed, formData);
  }

  // handleParsedData is the render path on its own, reachable without a
  // response to parse — which is what developer mode needs, and what kept the
  // dummy data from having to imitate the engine's wire format.
  function handleParsedData(parsed, formData) {
    submitBtn.classList.remove('loading'); submitBtn.disabled = false;
    lastResultsData = parsed; lastFormData = formData;
    showInlineResults(formData, parsed);
    saveToHistory(formData, parsed);
  }

  function handleApiError(err) {
    console.error('Kundli API error:', err.message);
    submitBtn.classList.remove('loading'); submitBtn.disabled = false;
    errorText.textContent = err.message || 'Unable to generate Kundli.';
    apiError.classList.add('visible'); setStep(1);
  }

  // ===== ACTIONS =====
  // The two PDF buttons that used to be here are gone with the markup: the
  // Documents card is where a document is downloaded from now.
  // ==============================================================
  //  DIVYA RATNA — PDF LOOKUP TABLES
  // ==============================================================

  // ==============================================================
  //  DOCUMENTS
  //
  //  The PDFs are typeset by the astrology API and served from the proxy's
  //  store. This page used to build its own in the browser with html2canvas
  //  and jsPDF — eighty kilobytes of code that screenshotted DOM nodes onto
  //  A4 pages, blocked the main thread for seconds on a phone, and produced a
  //  visibly poorer document than the engine already renders. That is all
  //  gone; what is left is a link.
  //
  //  A customer who has paid holds a token. The token is the entitlement:
  //  unguessable, derived from their verified payment, and enough on its own
  //  to fetch the documents again from any browser at any time. On a store
  //  with no accounts, that is what stands in for "my orders" — and it is why
  //  a refresh, a closed tab or a visit next month never asks them to pay
  //  twice.
  // ==============================================================

  var ORDER_TOKEN_KEY = 'km_orderToken';
  var lastOrder = null;          // the proxy's view of this customer's order
  var readingPoll = null;        // interval handle for the stage-two watcher
  var readingKicked = false;     // whether this page has asked for generation

  function showPdfToast(message, isError) {
    var toast = document.createElement('div');
    toast.textContent = message;
    toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:' +
      (isError ? '#c0392b' : '#27ae60') + ';color:#fff;padding:12px 22px;border-radius:8px;font-family:Inter,sans-serif;' +
      'font-size:0.9rem;z-index:100000;box-shadow:0 8px 24px rgba(0,0,0,0.25);max-width:90vw;text-align:center;';
    document.body.appendChild(toast);
    setTimeout(function() {
      toast.style.transition = 'opacity 0.4s';
      toast.style.opacity = '0';
      setTimeout(function() { if (toast.parentNode) toast.parentNode.removeChild(toast); }, 400);
    }, 4000);
  }

  function proxyPost(payload) {
    return fetch(API_ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(res) {
      return res.text().then(function(text) {
        var data = null;
        try { data = text ? JSON.parse(text) : null; } catch (e) { /* not JSON */ }
        if (!res.ok) throw new Error(describeApiError(data, res.status));
        if (!data) throw new Error('The server returned an empty response.');
        return data;
      });
    });
  }

  // ===== THE DOCUMENTS PANEL =====
  //
  // Built here rather than in the section markup so the whole feature lives in
  // one file, and so a theme that has not been re-saved still gets it.
  function documentsPanel() {
    var existing = document.getElementById('kmDocs-' + sId);
    if (existing) return existing;

    var card = document.createElement('div');
    card.className = 'kundli-glass-card visible';
    card.id = 'kmDocs-' + sId;
    card.innerHTML =
      '<div class="card-accent-line"></div>' +
      '<div class="card-title">📄 Your Documents' +
        (IS_DEV_MODE ? '<span style="margin-left:10px;font-size:0.68rem;font-weight:600;color:#ff6b35;' +
          'border:1px solid #ff6b35;border-radius:20px;padding:2px 10px;">DEV — simulated, ' +
          (EXPECTED_READING_MS / 1000) + 's instead of ~100s</span>' : '') +
      '</div>' +
      '<div id="kmDocsBody-' + sId + '"></div>' +
      '<div id="kmDocsLink-' + sId + '" style="margin-top:16px;padding:12px 14px;border-radius:10px;' +
        'background:rgba(0,0,0,0.03);border:1px dashed var(--border-c);display:none;">' +
        '<div style="font-size:0.78rem;opacity:0.7;margin-bottom:6px;">' +
          '🔗 Keep this link — it reopens your report any time, on any device. ' +
          'No login, and you are never charged again.</div>' +
        '<div style="font-size:0.78rem;margin-bottom:8px;">Your report code: ' +
          '<strong id="kmDocsCode-' + sId + '" style="font-family:ui-monospace,Menlo,monospace;' +
          'font-size:0.95rem;letter-spacing:2px;color:var(--accent);"></strong></div>' +
        '<div style="display:flex;gap:8px;align-items:center;flex-wrap:wrap;">' +
          '<input id="kmDocsUrl-' + sId + '" readonly style="flex:1;min-width:220px;font-size:0.78rem;' +
            'padding:8px 10px;border:1px solid var(--border-c);border-radius:8px;background:#fff;color:#555;">' +
          '<button type="button" id="kmDocsCopy-' + sId + '" class="kundli-action-btn share-btn" ' +
            'style="padding:8px 18px;font-size:0.82rem;">Copy</button>' +
        '</div>' +
      '</div>';

    var anchor = document.getElementById('kundliActions-' + sId);
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(card, anchor);
    else results.appendChild(card);

    card.querySelector('#kmDocsCopy-' + sId).addEventListener('click', function() {
      var input = document.getElementById('kmDocsUrl-' + sId);
      input.select();
      try { document.execCommand('copy'); showPdfToast('📋 Link copied.'); }
      catch (e) { showPdfToast('Select the link and copy it.', true); }
    });
    return card;
  }

  function docButton(href, icon, label, note) {
    // In developer mode there is no stored document behind the link, so the
    // button says so rather than sending the browser to a 404.
    var el = (href === DEV_DOC_HREF)
      ? '<button type="button" class="divya-pdf-btn km-dev-doc" style="margin:0 8px 8px 0;">' +
          '<span class="btn-icon">' + icon + '</span><span>' + label + '</span></button>'
      : '<a href="' + href + '?download=1" class="divya-pdf-btn" style="text-decoration:none;margin:0 8px 8px 0;">' +
          '<span class="btn-icon">' + icon + '</span><span>' + label + '</span></a>';
    return el + (note ? '<div style="font-size:0.75rem;opacity:0.6;margin:-2px 0 12px;">' + note + '</div>' : '');
  }

  var DEV_DOC_HREF = '#dev-no-document';

  // renderDocuments reflects whatever the proxy currently reports. It is safe
  // to call repeatedly — each poll simply redraws the same panel.
  function renderDocuments(order) {
    if (!order) return;
    lastOrder = order;
    var body = documentsPanel().querySelector('#kmDocsBody-' + sId);
    var docs = order.documents || {};
    var html = '';

    if (docs.kundli) {
      html += docButton(docs.kundli, '📜', 'Download Your Kundli',
        '18 pages — charts, dashas, ashtakavarga, strengths, KP and remedies.');
    } else if (order.kundli === 'failed') {
      html += '<div style="color:var(--danger-c);font-size:0.85rem;margin-bottom:12px;">' +
        'The chart document could not be typeset. Your reading is unaffected — ' +
        'reload this page and it will be retried.</div>';
    }

    if (docs.reading) {
      html += docButton(docs.reading, '📖', 'Download Kundli + Reading',
        'The full book: your chart and the written interpretation of it.');
    } else if (order.reading === 'failed') {
      html += '<div style="padding:12px 14px;border-radius:10px;background:#fef0ef;border:1px solid #f5c6cb;' +
        'color:#c0392b;font-size:0.85rem;margin-bottom:8px;">' +
        '⚠️ The written reading could not be produced this time. Your chart above is complete and yours. ' +
        '<button type="button" id="kmRetryReading-' + sId + '" style="background:none;border:none;color:#c0392b;' +
        'text-decoration:underline;cursor:pointer;font-size:0.85rem;padding:0;">Try again</button></div>';
    } else if (order.reading === 'pending' || order.reading === 'generating') {
      html += '<div id="kmReadingProg-' + sId + '" style="padding:16px 18px;border-radius:10px;' +
        'background:rgba(200,155,45,0.06);border:1px solid rgba(200,155,45,0.2);margin-bottom:8px;">' +
        '<div style="display:flex;align-items:center;gap:12px;margin-bottom:10px;">' +
          '<span style="display:inline-block;width:20px;height:20px;flex:0 0 20px;' +
            'border:2.5px solid rgba(200,155,45,0.3);border-top-color:var(--accent);border-radius:50%;' +
            'animation:kundliSpin 0.8s linear infinite;"></span>' +
          '<div style="font-weight:600;color:var(--heading-c);">Writing your reading…</div>' +
          '<div id="kmReadingPct-' + sId + '" style="margin-left:auto;font-size:0.8rem;font-weight:600;' +
            'color:var(--accent);font-variant-numeric:tabular-nums;">0%</div>' +
        '</div>' +
        '<div style="height:7px;border-radius:4px;background:rgba(200,155,45,0.15);overflow:hidden;">' +
          '<div id="kmReadingBar-' + sId + '" style="height:100%;width:0%;border-radius:4px;' +
            'background:linear-gradient(90deg,var(--accent),#8B2E2E);transition:width 0.9s linear;"></div>' +
        '</div>' +
        '<div id="kmReadingNote-' + sId + '" style="font-size:0.78rem;opacity:0.7;margin-top:8px;">' +
          'Your chart above is ready to download now. You can close this page — the link below brings ' +
          'the finished reading back whenever you want it.</div>' +
      '</div>';
    }

    // A response carrying neither a document nor a status matches none of the
    // branches above. Rendering an empty card there tells the customer
    // nothing; the link below is the part that still matters, so say so.
    if (!html) {
      html = '<div style="font-size:0.85rem;opacity:0.75;">' +
        'Your documents are being prepared. Keep the link below — it will have them.</div>';
    }
    body.innerHTML = html;

    var retry = document.getElementById('kmRetryReading-' + sId);
    if (retry) retry.addEventListener('click', function() { kickReading(true); });

    body.querySelectorAll('.km-dev-doc').forEach(function(b) {
      b.addEventListener('click', function() {
        showPdfToast('Developer mode — the real document comes from the proxy after payment.', true);
      });
    });

    // Run the bar only while there is something to report.
    if (order.reading === 'pending' || order.reading === 'generating') {
      startReadingProgress(order);
    } else {
      stopReadingProgress();
    }

    // The permanent link appears as soon as there is anything to retrieve.
    if (order.token) {
      var wrap = document.getElementById('kmDocsLink-' + sId);
      var input = document.getElementById('kmDocsUrl-' + sId);
      input.value = window.location.origin + window.location.pathname + '?report=' + order.token;
      var code = document.getElementById('kmDocsCode-' + sId);
      if (code) code.textContent = order.token;
      wrap.style.display = 'block';
    }
  }

  // ===== THE PROGRESS BAR =====
  //
  // A measured reading takes about a minute and a half, so the bar is driven
  // by real elapsed time against that, not by a fake animation. Two things
  // keep it honest:
  //
  //   - Elapsed is counted from readingStartedAt, which the proxy records when
  //     it actually begins. A customer who refreshes at the sixty-second mark
  //     sees a bar two thirds along, not one starting again from zero.
  //   - It stops at 95%. A bar that reaches 100% and then sits there is worse
  //     than one that never claims to be finished, because the customer starts
  //     wondering whether it broke. It only completes when the file does, and
  //     if the estimate is overrun the wording says so rather than the bar
  //     silently lying.
  // Measured runs took 87–100s. Developer mode compresses this so the whole
  // arc can be watched in under half a minute; the label on the panel says so,
  // because a bar that fills in twenty seconds would otherwise teach you to
  // expect a speed the real thing does not have.
  var EXPECTED_READING_MS = IS_DEV_MODE ? 20000 : 100000;
  var readingTicker = null;
  var readingSeenAt = null;

  function stopReadingProgress() {
    if (readingTicker) { clearInterval(readingTicker); readingTicker = null; }
  }

  function startReadingProgress(order) {
    stopReadingProgress();
    var startedAt = Date.parse((order && order.readingStartedAt) || '') || null;
    if (!startedAt) {
      // The proxy has not started it yet, so count from when this page first
      // saw it rather than pretending to know.
      if (!readingSeenAt) readingSeenAt = Date.now();
      startedAt = readingSeenAt;
    }

    function paint() {
      var bar = document.getElementById('kmReadingBar-' + sId);
      var pct = document.getElementById('kmReadingPct-' + sId);
      var note = document.getElementById('kmReadingNote-' + sId);
      if (!bar || !pct) { stopReadingProgress(); return; }

      var elapsed = Date.now() - startedAt;
      var frac = Math.min(0.95, elapsed / EXPECTED_READING_MS);
      bar.style.width = (frac * 100).toFixed(0) + '%';
      pct.textContent = (frac * 100).toFixed(0) + '%';

      if (note && elapsed > EXPECTED_READING_MS) {
        note.textContent = 'This one is taking a little longer than usual — it is still being written, ' +
          'and it will appear here when it is done. Your chart above is ready now, and the link below ' +
          'brings the reading back later if you would rather not wait.';
      }
    }
    paint();
    readingTicker = setInterval(paint, 1000);
  }

  // ===== STAGE TWO: watch for the reading =====
  //
  // The proxy starts generating as soon as the chart is delivered, so most of
  // the time this only watches. It asks explicitly when the proxy reports the
  // work never got going — a worker can be evicted before its background task
  // runs — which is why generation is idempotent on that side.
  // The proxy's stale-lock window. A reading claiming to be in progress for
  // longer than this is not in progress: whatever was doing it is gone.
  var READING_STALE_MS = 160000;

  function kickReading(force) {
    if (!lastOrder || !lastOrder.token) return;
    if (readingKicked && !force) return;
    readingKicked = true;
    // This request is held open for as long as the writing takes — a minute
    // and a half or so — and that is the point of it. The browser holding the
    // connection is what keeps the proxy alive for the whole job. The proxy
    // used to start the work on its own and was cut off part way through,
    // losing the finished document.
    proxyPost({ action: 'generate-reading', token: lastOrder.token })
      .then(renderDocuments)
      .catch(function(err) {
        console.warn('[Kundli] reading request failed:', err.message);
        // Let the watcher try again rather than stopping here.
        readingKicked = false;
      });
  }

  // readingLooksDead reports a generation that stopped without saying so.
  function readingLooksDead(order) {
    if (!order || order.reading !== 'generating') return false;
    var startedAt = Date.parse(order.readingStartedAt || '') || 0;
    if (!startedAt) return false;
    return (Date.now() - startedAt) > READING_STALE_MS;
  }

  function watchReading() {
    if (readingPoll) clearInterval(readingPoll);
    if (!lastOrder || !lastOrder.token) return;
    if (lastOrder.reading === 'ready' || lastOrder.reading === 'failed') return;

    var polls = 0;
    readingPoll = setInterval(function() {
      polls++;
      // Give up watching after about ten minutes. The link still works; the
      // customer simply reopens it rather than leaving a tab spinning.
      if (polls > 120) { clearInterval(readingPoll); readingPoll = null; return; }

      proxyPost({ action: 'order-status', token: lastOrder.token })
        .then(function(order) {
          renderDocuments(order);
          if (order.reading === 'ready') {
            clearInterval(readingPoll); readingPoll = null;
            showPdfToast('📖 Your full reading is ready to download.');
          } else if (order.reading === 'failed') {
            clearInterval(readingPoll); readingPoll = null;
          } else if (order.reading === 'pending') {
            // Nothing has started it. Ask.
            kickReading(false);
          } else if (readingLooksDead(order)) {
            // It claims to be running, but for longer than any real run takes.
            // The proxy's lock has expired by now, so asking again restarts it
            // rather than being turned away.
            console.warn('[Kundli] the reading stalled; asking for it again');
            kickReading(true);
          }
        })
        .catch(function() { /* transient; the next tick tries again */ });
    }, 5000);
  }

  // ===== RETRIEVAL =====
  //
  // Two ways back in, because either one alone loses people: the token in this
  // browser's storage, and the token in the URL for anyone who saved the link
  // or moved to another device.
  // Ten Crockford base32 characters, or the 32 hex of a link issued before the
  // switch, which is still honoured so nobody's saved link stops working.
  var TOKEN_RE = /^([0-9A-HJKMNP-TV-Z]{10}|[a-f0-9]{32})$/;

  function storedToken() {
    var fromUrl = new URLSearchParams(window.location.search).get('report');
    // Uppercased first: the code is read off a screen and typed back, and
    // people type it in lower case.
    if (fromUrl) fromUrl = fromUrl.trim().toUpperCase();
    if (fromUrl && TOKEN_RE.test(fromUrl)) {
      lsSet(ORDER_TOKEN_KEY, fromUrl);
      return fromUrl;
    }
    // The old form is lower-case hex, so it fails the uppercase test above and
    // is checked separately against what was stored.
    var raw = new URLSearchParams(window.location.search).get('report');
    if (raw && /^[a-f0-9]{32}$/.test(raw.trim())) {
      lsSet(ORDER_TOKEN_KEY, raw.trim());
      return raw.trim();
    }
    var saved = lsGet(ORDER_TOKEN_KEY);
    return (saved && TOKEN_RE.test(saved)) ? saved : null;
  }

  function restoreOrder() {
    var token = storedToken();
    if (!token) return;

    proxyPost({ action: 'order-status', token: token })
      .then(function(order) {
        if (!order || !order.success) return;
        // Rebuild the page from what was stored, so a returning customer sees
        // their chart and not an empty form.
        var parsed = parseApiData(order);
        var formData = birthToFormData(order.birth);
        if (parsed && formData) {
          lastResultsData = parsed;
          lastFormData = formData;
          showInlineResults(formData, parsed);
        }
        renderDocuments(order);
        watchReading();
        if (order.reading === 'pending' || readingLooksDead(order)) kickReading(true);
      })
      .catch(function(err) {
        // A token that no longer resolves is not worth keeping.
        if (/no report found/i.test(err.message || '')) lsSet(ORDER_TOKEN_KEY, '');
        console.warn('[Kundli] could not restore a previous report:', err.message);
      });
  }

  // The stored birth record is in the API's vocabulary; the renderers want the
  // form's. This is the inverse of buildBirthRecord.
  function birthToFormData(birth) {
    if (!birth) return null;
    return {
      name: birth.name || '', gender: birth.gender || 'male',
      dob: birth.birthDate || '', tob: birth.birthTime || '',
      timezone: birth.timezone || '', place: birth.place || '',
      latitude: birth.latitude, longitude: birth.longitude,
      date: birth.birthDate || '', time: (birth.birthTime || '') + ':00'
    };
  }

  saveBtn.addEventListener('click', function() {
    if (!lastFormData) return;
    var dataStr = JSON.stringify({ form: lastFormData, chart: lastResultsData }, null, 2);
    var blob = new Blob([dataStr], { type: 'application/json' }); var url = URL.createObjectURL(blob);
    var a = document.createElement('a'); a.href = url; a.download = (lastFormData.name || 'kundli') + '-chart.json'; a.click(); URL.revokeObjectURL(url);
  });
  shareBtn.addEventListener('click', function() {
    if (!lastFormData) return;
    var shareData = { title: lastFormData.name + "'s Kundli", text: '🔮 ' + lastFormData.name + "'s birth chart! Nakshatra: " + (lastResultsData ? lastResultsData.nakshatra : '') + ' | Rashi: ' + (lastResultsData ? lastResultsData.rashi : ''), url: window.location.href };
    if (navigator.share) { navigator.share(shareData).catch(function() {}); } else {
      var ta = document.createElement('textarea'); ta.value = shareData.text + '\n' + shareData.url; document.body.appendChild(ta); ta.select(); document.execCommand('copy'); document.body.removeChild(ta); alert('📋 Copied to clipboard!');
    }
  });
  closeBtn.addEventListener('click', function() { overlay.classList.remove('open'); document.body.style.overflow = ''; });
  overlay.addEventListener('click', function(e) { if (e.target === overlay) { overlay.classList.remove('open'); document.body.style.overflow = ''; } });
  document.addEventListener('keydown', function(e) { if (e.key === 'Escape' && overlay.classList.contains('open')) { overlay.classList.remove('open'); document.body.style.overflow = ''; } });

  // ===== AUTO-CLEAR ERRORS =====
  document.querySelectorAll('#kundliForm-' + sId + ' input, #kundliForm-' + sId + ' select').forEach(function(input) {
    input.addEventListener('input', function() { this.classList.remove('error'); var errorEl = this.parentElement.querySelector('.error-message'); if (errorEl) errorEl.classList.remove('visible'); });
  });

  // ===== CHART STYLE TOGGLE =====
  function setupChartStyleToggle() {
    document.getElementById('chartStyleSouth-' + sId).addEventListener('click', function() {
      document.getElementById('chartStyleSouth-' + sId).classList.add('active');
      document.getElementById('chartStyleNorth-' + sId).classList.remove('active');
      document.getElementById('chartSouth-' + sId).style.display = 'block';
      document.getElementById('chartNorth-' + sId).style.display = 'none';
    });
    document.getElementById('chartStyleNorth-' + sId).addEventListener('click', function() {
      document.getElementById('chartStyleNorth-' + sId).classList.add('active');
      document.getElementById('chartStyleSouth-' + sId).classList.remove('active');
      document.getElementById('chartNorth-' + sId).style.display = 'block';
      document.getElementById('chartSouth-' + sId).style.display = 'none';
    });
  }

  // ===== PAYMENT RECOVERY: Check for pending payment on page load =====
  function checkPendingPayment() {
    try {
      var pendingPaymentStr = localStorage.getItem('km_pendingPayment');
      var pendingFormDataStr = localStorage.getItem('km_pendingFormData');
      
      if (!pendingPaymentStr || !pendingFormDataStr) {
        // Legacy fallback: check sessionStorage and migrate
        try {
          pendingPaymentStr = sessionStorage.getItem('km_pendingPayment');
          pendingFormDataStr = sessionStorage.getItem('km_pendingFormData');
          if (pendingPaymentStr && pendingFormDataStr) {
            localStorage.setItem('km_pendingPayment', pendingPaymentStr);
            localStorage.setItem('km_pendingFormData', pendingFormDataStr);
            sessionStorage.removeItem('km_pendingPayment');
            sessionStorage.removeItem('km_pendingFormData');
          }
        } catch(e) {}
      }
      
      if (!pendingPaymentStr || !pendingFormDataStr) return;
      
      var paymentData = JSON.parse(pendingPaymentStr);
      var formData = JSON.parse(pendingFormDataStr);
      
      if (!paymentData.razorpay_payment_id || !paymentData.razorpay_order_id || !paymentData.razorpay_signature) {
        // Invalid or expired payment data
        sessionStorage.removeItem('km_pendingPayment');
        sessionStorage.removeItem('km_pendingFormData');
        return;
      }
      
      // Also validate that form data has required fields
      if (!formData.name || !formData.latitude || !formData.longitude) {
        // Incomplete form data — can't retry
        sessionStorage.removeItem('km_pendingPayment');
        sessionStorage.removeItem('km_pendingFormData');
        return;
      }
      
      // Populate the form with the pending form data so user can see what they entered
      var nameInput = document.getElementById('personName-' + sId);
      var placeInput = document.getElementById('personPlace-' + sId);
      var dobInput = document.getElementById('personDob-' + sId);
      var tobInput = document.getElementById('personTob-' + sId);
      if (nameInput && formData.name) nameInput.value = formData.name;
      if (dobInput && formData.dob) dobInput.value = formData.dob;
      if (tobInput && formData.tob) tobInput.value = formData.tob;
      if (placeInput && formData.place) {
        placeInput.value = formData.place;
        placeInput.dataset.lat = formData.latitude;
        placeInput.dataset.lon = formData.longitude;
      }
      
      // Show the recovery banner
      var recoveryCard = document.getElementById('paymentRecoveryCard-' + sId);
      if (recoveryCard) {
        recoveryCard.style.display = 'block';
        recoveryCard.classList.add('visible');
        // Scroll to the recovery card
        setTimeout(function() { recoveryCard.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300);
      }
    } catch(e) {
      // Silently fail — sessionStorage might be unavailable
      console.warn('[Kundli] Failed to check pending payment:', e.message);
    }
  }

  // ===== PAYMENT RECOVERY: Retry button handler =====
  function setupPaymentRecovery() {
    var retryBtn = document.getElementById('paymentRecoveryRetryBtn-' + sId);
    var dismissBtn = document.getElementById('paymentRecoveryDismissBtn-' + sId);
    var recoveryCard = document.getElementById('paymentRecoveryCard-' + sId);
    
    if (retryBtn) {
      retryBtn.addEventListener('click', function() {
        var btn = this;
        btn.classList.add('loading');
        btn.disabled = true;
        
        // Clear any previous errors
        apiError.classList.remove('visible');
        errorText.textContent = '';
        results.classList.remove('visible');
        
        setStep(2);
        
        // Get pending payment data from localStorage (with sessionStorage fallback)
        var pendingPaymentStr = localStorage.getItem('km_pendingPayment');
        var pendingFormDataStr = localStorage.getItem('km_pendingFormData');
        if (!pendingPaymentStr || !pendingFormDataStr) {
          pendingPaymentStr = sessionStorage.getItem('km_pendingPayment');
          pendingFormDataStr = sessionStorage.getItem('km_pendingFormData');
        }
        
        if (!pendingPaymentStr || !pendingFormDataStr) {
          btn.classList.remove('loading');
          btn.disabled = false;
          errorText.textContent = 'No pending payment found. Please fill in your details and try again.';
          apiError.classList.add('visible');
          setStep(1);
          if (recoveryCard) recoveryCard.style.display = 'none';
          return;
        }
        
        var paymentData = JSON.parse(pendingPaymentStr);
        var formData = JSON.parse(pendingFormDataStr);
        
        // Restore storedPayment in memory
        storedPayment = {
          razorpay_payment_id: paymentData.razorpay_payment_id,
          razorpay_order_id: paymentData.razorpay_order_id,
          razorpay_signature: paymentData.razorpay_signature
        };
        
        // Use the verify-and-retry endpoint (bypasses Razorpay order creation)
        // We use a modified callApi that sends action: 'verify-and-retry'
        var payload = {
          action: 'verify-and-retry',
          type: 'making',
          birth: buildBirthRecord(formData),
          razorpay_payment_id: paymentData.razorpay_payment_id,
          razorpay_order_id: paymentData.razorpay_order_id,
          razorpay_signature: paymentData.razorpay_signature
        };
        
        // Use AbortController for timeout (30 seconds)
        var controller = new AbortController();
        var timeoutId = setTimeout(function() { controller.abort(); }, 120000);
        
        fetch(API_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
          signal: controller.signal
        })
        .then(function(res) {
          clearTimeout(timeoutId);
          return res.text().then(function(text) {
            if (!text || text.trim() === '') {
              throw new Error('Server returned empty response. Please try again.');
            }
            try {
              var data = JSON.parse(text);
              if (!res.ok) {
                throw new Error(data.error || 'Retry failed (HTTP ' + res.status + ')');
              }
              return data;
            } catch (e) {
              if (e instanceof SyntaxError) {
                throw new Error('Invalid response from server. Please try again.');
              }
              throw e;
            }
          });
        })
        .then(function(json) {
          // Success — clear pending payment and show results
          clearPendingPayment();
          handleApiSuccess(json, formData);
          if (recoveryCard) {
            recoveryCard.style.display = 'none';
            recoveryCard.classList.remove('visible');
          }
        })
        .catch(function(err) {
          clearTimeout(timeoutId);
          btn.classList.remove('loading');
          btn.disabled = false;
          
          if (err.name === 'AbortError') {
            errorText.textContent = '⏱️ Request timed out. Our server took too long to respond. Your payment is safe. Please try again.';
          } else {
            errorText.textContent = err.message || 'Retry failed. Your payment is safe. Please try again or contact support.';
          }
          apiError.classList.add('visible');
          setStep(1);
        });
      });
    }
    
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function() {
        // Hide the recovery card but keep payment in sessionStorage
        // User can come back later
        if (recoveryCard) {
          recoveryCard.style.display = 'none';
          recoveryCard.classList.remove('visible');
        }
        setStep(1);
      });
    }
  }

  // ===== CLEAR PENDING PAYMENT =====
  function clearPendingPayment() {
    try {
      localStorage.removeItem('km_pendingPayment');
      localStorage.removeItem('km_pendingFormData');
      sessionStorage.removeItem('km_pendingPayment');
      sessionStorage.removeItem('km_pendingFormData');
    } catch(e) {}
  }

  // ===== UPDATE handleApiSuccess to clear payment + surface the download button =====
  var originalHandleApiSuccess = handleApiSuccess;
  handleApiSuccess = function(json, formData) {
    // The token goes down FIRST, before a single pixel is drawn.
    //
    // It used to be written after the results had rendered, which meant any
    // error anywhere in that rendering — one unexpected field, one renderer
    // throwing — took the token with it. The customer had paid, the report
    // existed on the server, and the one string that could reach it again was
    // never saved. They would have had to pay a second time.
    //
    // Storing it first costs nothing and cannot fail in a way that matters:
    // lsSet swallows its own errors, and if the rendering then breaks, the
    // customer still has a working link to everything they bought.
    if (json && json.token) {
      lsSet(ORDER_TOKEN_KEY, json.token);
      try {
        window.history.replaceState({}, '', window.location.pathname + '?report=' + json.token);
      } catch (e) { /* older browsers: the stored token still covers it */ }
    }

    clearPendingPayment();

    // Rendering the results and offering the documents are separate concerns,
    // and a failure in the first must not hide the second. Before, they were
    // one sequence: a renderer throwing meant no download panel at all, which
    // is what a customer reported — a full chart on screen and no way to get
    // the PDF they had paid for.
    try {
      originalHandleApiSuccess(json, formData);
    } catch (err) {
      console.error('[Kundli] results rendering failed:', err);
      submitBtn.classList.remove('loading'); submitBtn.disabled = false;
    }

    try {
      renderDocuments(json);
      kickReading(false);
      watchReading();
    } catch (err) {
      console.error('[Kundli] documents panel failed:', err);
    }

    setTimeout(function() {
      var panel = document.getElementById('kmDocs-' + sId);
      if (!panel) return;
      panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
      panel.style.transition = 'box-shadow 0.4s';
      panel.style.boxShadow = '0 0 0 6px rgba(200,155,45,0.35)';
      setTimeout(function() { panel.style.boxShadow = ''; }, 1600);
    }, 600);
  };

  // ===== UPDATE handleApiError with better messages =====
  var originalHandleApiError = handleApiError;
  handleApiError = function(err) {
    console.error('Kundli API error:', err.message);
    submitBtn.classList.remove('loading'); submitBtn.disabled = false;
    
    // Check if the user actually paid (storedPayment exists or pending payment in localStorage)
    var hasPayment = storedPayment !== null;
    if (!hasPayment) {
      try {
        hasPayment = localStorage.getItem('km_pendingPayment') !== null;
        if (!hasPayment) {
          hasPayment = sessionStorage.getItem('km_pendingPayment') !== null;
        }
      } catch(e) {}
    }
    
    if (hasPayment) {
      // Payment was made but API call failed — show recovery guidance
      errorText.textContent = '⚠️ ' + (err.message || 'Unable to generate chart') + 
        '. Your payment was successful. Please use the green recovery card above to retry without being charged again.';
    } else {
      errorText.textContent = err.message || 'Unable to generate Kundli. Please try again.';
    }
    
    apiError.classList.add('visible');
    setStep(1);
  };

  // ===== ADD TIMEOUT TO callApi (30 seconds) =====
  var originalCallApi = callApi;
  callApi = function(formData) {
    var payload = {
      type: 'making',
      birth: buildBirthRecord(formData)
    };
    // Include payment details if available
    if (storedPayment) {
      payload.razorpay_payment_id = storedPayment.razorpay_payment_id;
      payload.razorpay_order_id = storedPayment.razorpay_order_id;
      payload.razorpay_signature = storedPayment.razorpay_signature;
    }
    
    // Two minutes, not thirty seconds. Typesetting the chart shells out to
    // headless Chrome on the API host, and its first run after an idle period
    // is slow enough that a thirty-second abort killed requests the server was
    // about to answer — from the customer's side, paying and getting nothing.
    var controller = new AbortController();
    var timeoutId = setTimeout(function() { controller.abort(); }, 120000);

    return fetch(API_ENDPOINT, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
      signal: controller.signal
    }).then(function(res) {
      clearTimeout(timeoutId);
      // Try to get response text first, then parse as JSON
      return res.text().then(function(text) {
        if (!text || text.trim() === '') {
          if (!res.ok) {
            throw new Error('Server returned HTTP ' + res.status + ' with empty response. Check worker logs.');
          }
          throw new Error('Received empty response from server. Check worker configuration.');
        }
        try {
          var data = JSON.parse(text);
          if (!res.ok) {
            // If payment is required (402), throw a specific error
            if (res.status === 402) {
              throw new Error(data.error || 'Payment required. Please complete payment of ₹490.');
            }
            throw new Error(describeApiError(data, res.status));
          }
          return data;
        } catch (e) {
          if (e instanceof SyntaxError) {
            throw new Error('Invalid response from server (not JSON). Status: ' + res.status + '. Response: ' + text.substring(0, 100));
          }
          throw e;
        }
      });
    }).catch(function(err) {
      clearTimeout(timeoutId);
      if (err.name === 'AbortError') {
        throw new Error('Request timed out. Our server took too long to respond. Your payment is safe. Please use the recovery option above to retry.');
      }
      throw err;
    });
  };

  // ===== INIT =====
  setStep(1); renderHistory(); setupTabs(); setupChartStyleToggle(); initParticles();
  checkPendingPayment();
  setupPaymentRecovery();
  // A customer who already bought one gets it back rather than a blank form.
  restoreOrder();
};
